// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/Rectangle 10.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/chat_bg_container.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-bg-container {
  background-color: #022636;
  padding: 15px;
  padding-left: 0px;
  display: flex;
  width: 100vw;
  height: 100vh;
  /* animation: scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both; */
}

body{
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  /* background-color:  #2E7D92 !important; */
  /* background: radial-gradient(circle, 
  #A6D3DE 0%, 
  #4F94A8 30%,
  #1A6E84 60%, 
  #094762 100% 
); */
font-family: "Inter", serif!important;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;

}

.transition-bg-container {
  /* background-image: linear-gradient(to right, #083d53, #729caf, #4f7871); */
  padding: 15px;
  padding-left: 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 100vh;
  /* animation: scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both; */
}
.sidebar-bg-container {
  width: 20%;
  /* background-color: blue; */
  padding: 15px;
}

.input-box {
  position: relative; /* Make the container relative */
  width: 100%;
}

.input-box input {
  width: 100%;
  padding-right: 35px; /* Add padding to the right to make space for the icon */
}

.input-box .icon {
  position: absolute;
  right: 10px;
  top: 65%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 25px;
  color: #000;
}

.app-content-container {
  width: 80%;
  height: 100%;
  border-radius: 44px;
  background: #d1e7f1;
  box-shadow: 0px 4px 11.4px 0px rgba(0, 0, 0, 0.17);
}

.app-main-bg-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.app-main-bg-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.app-main-bg-container::-webkit-scrollbar-thumb {
  background: blue;
  /* Customize the scrollbar thumb color */
}

.app-main-bg-container::-webkit-scrollbar-thumb:hover {
  background: violet;
  /* Customize the scrollbar thumb color on hover */
}

.new-sidebar {
  /* background-color: #f9f9f9; */
  width: 100%;
  height: 100%;
  padding: 0px;
}

.new-sidebar-content-container {
  height: 90%;
  /* background-color: skyblue; */
}

.user-logout-container {
  height: 10%;
  position: relative;
  /* background-color: bisque; */
}

.user-logo-container {
  width: 44.955px;
  height: 44.955px;
  flex-shrink: 0;
  background-image: linear-gradient(180deg, #2C7B74 0%, #0664AE 100%);
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 75%;
}

.user-logo-text {
  color: #FFF;
  font-size: 20px;
  font-weight: 600;
  margin: 0px;
}

.logout-container {
  border-radius: 12px;
  /* opacity: 0.4; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  width: 80%;
  height: 44.955px;
  padding: 10px;
  background-size: cover;
  cursor: pointer;
}

.logout-text {
  margin: 0px;
  color: #FFF;
  font-size: 15px;
  font-weight: 600;
}

.logout-text-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
}

.logout-icon {
  color: #FFF;
  font-size: 15px;
  font-weight: 600;
}

.enmovil-logo-container {
  width: 100%;
  height: 13%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.chat-name-container {
  width: 100%;
  border-radius: 27.438px;
  border: 0px solid rgba(98, 211, 167, 0.00);
  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.00) 100%);
  backdrop-filter: blur(64.0224838256836px);
  padding: 10px;
}

.selct-chat-name-container {
  width: 100%;
  padding: 15px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

/* .chat-name-container:hover {
  border-radius: 27.438px;
  border: 0px solid rgba(98, 211, 167, 0.00);
  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.00) 100%);
  backdrop-filter: blur(64.0224838256836px);
  padding: 10px;
} */

.copy-link-popup-container {
  width: 450px;
  height: 195px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #FFF;
  font-size: 30px;
  font-weight: bold;
  font-weight: 600;
  border-radius: 57.515px;
  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));
  padding: 20px;
}

.copy-txt {
  color: #FFF;
  font-size: 25px;
  font-weight: bold;
  font-weight: 600;
}

.chat-name-bg-container {
  border-radius: 27.438px;
  border: 0px solid rgba(98, 211, 167, 0.00);
  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.00) 100%);
  backdrop-filter: blur(64.0224838256836px);
  /* background-image: url("../../assets/images/Rectangle\\ 5.png"); */
  padding: 10px;
  width: 100%;
  /* padding-left: 20px;
  padding-right: 20px; */
}
.pinpopup-chat-name-bg-container{
  height: 210px;
  overflow-y: auto;
  border-radius: 27.438px;
  border: 0px solid rgba(98, 211, 167, 0.00);
  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.00) 100%);
  backdrop-filter: blur(64.0224838256836px);
  /* background-image: url("../../assets/images/Rectangle\\ 5.png"); */
  padding: 10px;
  width: 100%;
}
.pinpopup-chat-name-bg-container::-webkit-scrollbar {
  width: 5px !important;
  height: 0;
  border-radius: 5px;
}

.pinpopup-chat-name-bg-container::-webkit-scrollbar-thumb {
  background: rgb(215, 215, 217) !important;
  height: 10px !important;
}

.pinpopup-chat-name-bg-container::-webkit-scrollbar-thumb:hover {
  background: rgb(139, 97, 97);
}

.pinpopup-chat-name-bg-container::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 5px;
  height: 5px !important;
}
.chat-history-name {
  margin: 0px;
  color: #FFF;
  font-size: 18.354px;
  font-weight: 600;
}

.new-chat-text-container {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 20px;
}

.new-text {
  margin: 0px;
  color: #FFF;
  font-size: 14px;
  font-weight: 600;
}

.new-message-icon {
  color: #fff;
  font-size: 17px;
  margin-right: 5px;
}

.previous-history-name {
  margin: 0px;
  color: #ffffff;
  font-size: 17px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 5px;
  padding-left: 15px;
  z-index: 1000;
}

.chat-name-text {
  color: #fff;
  font-size: 15px;
  margin: 0px;
  margin-left: 10px;
}

.content-bg-container {
  width: 80%;
  height: 100%;
  background-color: #e7e5e5;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.chat-container {
  width: 80%;
  height: 100%;
}

.content-header-container {
  background-color: transparent;
  width: 90%;
  z-index: 1000;
  padding: 20px;
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: 1px solid #8bb5dc;
}

.dashboard-header-container {
  background-color: transparent;
  width: 95%;
  height: 10%;
  z-index: 1000;
  padding: 30px;
  padding-top: 40px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid #8bb5dc;
  position: sticky;
}

.share-popup-container {
  width: 450px;
  height: 195px;
  border-radius: 23px;
  background: #FFF;
  position: relative;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.share-chat-with-link {
  font-size: 25px;
  font-weight: bold;
  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.generate-link {
  width: 151.657px;
  height: 39.91px;
  flex-shrink: 0;
  color: #fff;
  border-radius: 9.484px;
  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));
  border: 0px;
}

/* .app-container{
    background-color: #f5f5f5;
    display: flex;
    height: 92vh;
}
.navbar {
    background-color: #f9f9f9;
    width: 100%;
    height: 8vh;
    border-bottom: 1px solid #EAEAEA;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .navbar-logo-container{
    width: 15%;
    height: 100%;
    padding-left: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .navbar-logo{
    width: 80%;
    height: 70%;
  } */
.content {
  /* background-color: # ; */
  width: 80%;
  padding: 20px;
  /* border: #000 0.5px solid; */
}

.new-chat-text {
  color: #000;
  font-size: 20px;
  font-weight: 600;
  margin: 0px;
}

.edit-icon {
  width: 25px;
  height: 25px;
  flex-shrink: 0;
  margin-left: 20px;
  cursor: pointer;
  color: #0664AE;
}

.new-edit-icon {
  font-size: 1vw;
  flex-shrink: 0;
  margin-right: 5px;
  color: #0664AE;
}

.sidebar-content-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.sidebar-content-container::-webkit-scrollbar-thumb {
  background: blue;
  /* Customize the scrollbar thumb color */
}

.sidebar-content-container::-webkit-scrollbar-thumb:hover {
  background: violet;
  /* Customize the scrollbar thumb color on hover */
}

.alternate_chat_input {
  padding: 7px;
  padding-left: 10px;
  border: 1px solid #2C7B74;
  border-radius: 10px;
  box-shadow: 0px 4px 11.4px 0px rgba(0, 0, 0, 0.17);
  width: 60%;
  color: #000;
  font-size: 17px;
  outline: none;
}

.new-chat-bg-container {
  height: 15%;
  border-top: 3px solid #e1dede;
  display: flex;
  justify-content: center;
  align-items: center;
}

.new-chat-container {
  border: 1px solid #8F8686;
  border-radius: 10px;
  height: 57%;
  width: 100%;
  display: flex;
}

.plus-icon-container {
  width: 20%;
  height: 100%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.new-chat-txt-container {
  display: flex;
  align-items: center;
  width: 80%;
}

.chat-result-text {
  /* color: #504E4E; */
  color: #000;
  font-size: 17px;
  font-weight: 500;
}

.chat-user-logo-container {
  background: linear-gradient(180deg, #2C7B74 0%, #0664AE 100%);
  width: 44.955px;
  height: 44.955px;
  flex-shrink: 0;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ai-result-text-container {
  padding-left: 20px;
  padding-right: 20px;
  max-height: 570px;
  width: 100%;
  position: relative;
  overflow-y: auto;
}

.f17 {
  font-size: 17px;
}

.f23 {
  font-size: 23px;
}

.f13 {
  font-size: 13px;
}

.f15 {
  font-size: 15px;
}

.f19 {
  font-size: 19px;
}

.mt5p {
  margin-top: 5px;
}

.ml5p {
  margin-left: 5px;
}

.mr5p {
  margin-right: 5px;
}

.pl10p {
  padding-left: 10px;
}

.mt10p {
  margin-top: 10px;
}

.mr10p {
  margin-right: 10px;
}

.m0p {
  margin: 0px;
}

.f-bold {
  font-weight: bold;
}

.f-500 {
  font-weight: 500;
}

.f-600 {
  font-weight: 600;
}

.f-700 {
  font-weight: 700;
}

.pl10 {
  padding-left: 40px
}

.pr10 {
  padding-right: 40px
}

.black {
  color: black;
}

.sidebar-icon {
  position: absolute;
  left: 90%;
  cursor: pointer;
}

.content-sidebar-icon {
  position: absolute;
  right: 97%;
  top: 13%;
  cursor: pointer;
}

.popup {
  /* Popup styles */
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  top: 10px;
  left: 40px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}
.new-popup {
  /* Popup styles */
  position: absolute;
  background-color: #f9f9f9;
  color: blue;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  top: 0;
  left: 0;
  opacity: 0;
  width: 400px;
  height: 150px;
  transition: opacity 0.2s ease-in-out;
}

.full-content-bg-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-container {
  width: 100%;
  height: 78%;
  overflow-y: auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 50px;
}

.content-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.content-container::-webkit-scrollbar-thumb {
  background: blue;
  /* Customize the scrollbar thumb color */
}

.content-container::-webkit-scrollbar-thumb:hover {
  background: violet;
  /* Customize the scrollbar thumb color on hover */
}

.full-content-container {
  width: 100%;
  height: 85%;
  overflow-y: auto;
  position: relative;
  display: flex;
  justify-content: center;
  padding-top: 50px;
}

.full-content-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.full-content-container::-webkit-scrollbar-thumb {
  background: blue;
  /* Customize the scrollbar thumb color */
}

.full-content-container::-webkit-scrollbar-thumb:hover {
  background: violet;
  /* Customize the scrollbar thumb color on hover */
}

.tooltip {
  visibility: hidden;
  position: absolute;
  right: 50%;
  /* Position the tooltip on the right side of the icon */
  top: 50%;
  transform: translateY(-50%);
  background-color: #333;
  color: #fff;
  padding: 5px;
  border-radius: 4px;
  white-space: nowrap;
}

.chat-history-container:hover .tooltip {
  visibility: visible;
  /* Show the tooltip on hover */
}

.search-box-bg-container {
  display: flex;
  justify-content: center;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding-bottom: 10px;
}

.search-box-container {
  display: flex;
  flex-direction: column;
  width: 80%;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  border: 1px solid #022636;
}

.rocket-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5%;
  max-height: 50px;
  height: 50px;
  cursor: pointer;
}

.search-input {
  background-color: transparent;
  padding: 15px;
  width: 100%;
  border: none;
  font-size: 17px;
  color: black;
  font-weight: 500;
  padding-left: 0px;
  outline: none;
  /* Hide vertical scrollbar */
}

input[type="text"] {
  word-wrap: break-word;
  /* Allow text to wrap to the next line */
  white-space: normal;
  /* Allow text to wrap to the next line */
  overflow-wrap: break-word
}

.rocket-container {
  width: 100%;
  height: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 5px;
  padding-left: 7px;
  padding-right: 7px;
  margin-bottom: 5px;
}

.rocket-icon-bg-container {
  background-image: linear-gradient(to right, #022636, #175068);
}

.previous-chat-container {
  width: 80%;
  height: 100%;
  padding-top: 50px;
}

.dashboard-chat-container {
  width: 80vw;
  height: 98%;
  padding: 50px;
  overflow-y: scroll;
  position: relative;
}

.chat-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.chat-container::-webkit-scrollbar-thumb {
  background: blue;
  /* Customize the scrollbar thumb color */
}

.chat-container::-webkit-scrollbar-thumb:hover {
  background: violet;
  /* Customize the scrollbar thumb color on hover */
}

.previous-chat-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.previous-chat-container::-webkit-scrollbar-thumb {
  background: blue;
  /* Customize the scrollbar thumb color */
}

.previous-chat-container::-webkit-scrollbar-thumb:hover {
  background: violet;
  /* Customize the scrollbar thumb color on hover */
}

.chat-result-bg-container {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  position: relative;
}

.ai-result-bg-container {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  position: relative;
}

.chat-result-container {
  width: 100%;
  display: flex;
  align-items: flex-start;
  background: rgba(6, 100, 174, 0.13);
  padding: 20px;
}

.ai-result-container {
  width: 100%;
  display: flex;
  align-items: flex-start;
  background: #E4FFF5;
  padding: 20px;
  position: relative;
  padding-top: 30px;
}

.ai-logo-container {
  background: linear-gradient(180deg, #2C7B74 0%, #0664AE 100%);
  width: 44.955px;
  height: 44.955px;
  flex-shrink: 0;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.robot-logo {
  width: 50%;
}

.chat-result-text-container {
  width: 100%;
  margin-left: 10px;
  padding-right: 30px;
  overflow: auto;
  position: relative;
  max-height: 570px;
}

.chat-name-bg-container::-webkit-scrollbar {
  width: 5px !important;
  height: 0;
  border-radius: 5px;
}

.chat-name-bg-container::-webkit-scrollbar-thumb {
  background: rgb(215, 215, 217) !important;
  height: 10px !important;
}

.chat-name-bg-container::-webkit-scrollbar-thumb:hover {
  background: rgb(139, 97, 97);
}

.chat-name-bg-container::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 5px;
  height: 5px !important;
}

.type-loader {
  font-size: 24px;
  /* Adjust the font size as needed */
}

.dot {
  opacity: 0;
  animation: dotAnimation 1s infinite!important;
  animation-delay: 0.2s;
  display: inline-block;
  font-weight: bold;
}

@keyframes dotAnimation {
  0% {
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}

.bordered-table {
  border-collapse: collapse;
  border: 2px solid #FFC7C7;
  /* Adjust the border style and color as needed */
  background-color: #f9f9f9;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid #c39f9f;
  /* Adjust the border style and color as needed */
  padding: 8px;
  /* Adjust the cell padding as needed */
  text-align: left;
  /* Adjust the cell text alignment as needed */
}

.container {
  align-items: center;
  display: flex;
  justify-content: center;
  max-width: 1200px;
  width: 100%;
  height: 90vh;
}
.chat-result-text-container::-webkit-scrollbar {
  width: 10px !important;
  height: 0;
  border-radius: 5px;
}

.chat-result-text-container::-webkit-scrollbar-thumb {
  background: rgb(215, 215, 217) !important;
  height: 10px !important;
}

.chat-result-text-container::-webkit-scrollbar-thumb:hover {
  background: rgb(139, 97, 97);
}
.btun {
  align-items: center;
  background-color: #4d61fc;
  /* Replace with your color value */
  border-radius: 3px;
  border: 0;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  padding: 15px;
  transition: 0.2s;
  font-weight: bold;
}

.btun:hover {
  background-color: #2036de;
  /* Hover background color */
  transform: translateY(-2px);
}

form,
fieldset {
  border: 0;
  padding: 0;
  margin: 0;
}

strong {
  color: #2f2f2f;
  display: block;
  font-size: 40px;
}

span {
  color: #2f2f2f;
}

.login {
  border-radius: 5px;
  box-shadow: 0 7px 30px -10px rgba(150, 170, 180, 0.5);
  ;
  height: auto;
  max-width: 400px;
  padding: 40px 15px;
  text-align: center;
  width: 100%;

  .fas {
    color: #4d61fc;
    font-size: 35px;
    margin-bottom: 5px;
  }

  .user-fas {
    margin-top: 15px;
    font-size: 23px !important;
    cursor: pointer;
  }

  strong {
    color: #2f2f2f;
    display: block;
    font-size: 40px;
  }

  span {
    color: #2f2f2f;
  }

  .create-account {
    border-top: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    margin-top: 30px;
    padding-top: 30px;

    strong {
      font-size: 16px;
      margin-left: 5px;
      text-decoration: underline;
    }
  }
}

.login {
  background: #fff;
  /* Replace with your background color */

  .form {
    margin-top: 30px;
    padding: 0 20px;

    .form-row {
      position: relative;
      text-align: left;

      .fas {
        font-size: 15px;
        position: absolute;
        right: 10px;
        top: 30px;
      }

      &.bottom {
        display: flex;
        justify-content: space-between;

        .forgot {
          color: #4d61fc;
          /* Replace with your color value */
        }
      }

      &.button-login {
        margin-top: 50px;

        .fas {
          position: static;
        }
      }

      /* Style checkbox remenber */
      .form-check {
        input[type=checkbox]+label {
          color: #555;
          cursor: pointer;
          display: block;
        }

        input[type=checkbox] {
          display: none;
        }

        /* Style label input checkbox */
        input[type=checkbox]+label:before {
          border-radius: 3px;
          border: 1px solid #e2e2e2;
          color: transparent;
          content: "\\2714";
          display: inline-block;
          height: 15px;
          margin-right: 5px;
          transition: 0.2s;
          vertical-align: bottom;
          width: 15px;
          line-height: 16px;
          font-size: 12px;
          text-align: center;
        }

        /* Input active scale */
        input[type=checkbox]+label:active:before {
          transform: scale(1.1);
        }

        /* Color input checked */
        input[type=checkbox]:checked+label:before {
          background-color: #4d61fc;
          /* Replace with your color value */
          border-color: #4d61fc;
          /* Replace with your color value */
          color: #fff;
          /* Replace with your color value */
        }
      }
    }

    .form-label {
      color: #555;
      font-size: 12px;
    }
  }

  .form-password,
  .form-text {
    border-radius: 2px;
    border: 0;
    height: 40px;
    margin-bottom: 20px;
    padding: 0 40px 0 10px;
    width: 100%;
    background: #f1f1f1 no-repeat;
    transition: 100ms all linear 0s;

    /* Style and effect focus inputs */
    background-image: linear-gradient(109.6deg, rgba(116, 18, 203, 1) 11.2%, rgba(230, 46, 131, 1) 91.2%);
    background-size: 0 2px, 100% 1px;
    background-position: 50% 100%, 50% 100%;

    /* Effect transition */
    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);

    /* Focus active input */
    &:focus {
      background-size: 100% 2px, 100% 1px;
      outline: none;
    }
  }
}

.arrow {
  font-size: 20px;
  margin-left: 10px;
}

.select-chat-name-bg {
  border-radius: 12.689px;
  border: 0px solid rgba(98, 211, 167, 0.00);
  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.00) 100%);
  backdrop-filter: blur(10px);
  width: 100%;
  padding: 7px;
  padding-left: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: 'relative';
  margin-bottom: 5px;
}

.chat-name-bg {
  /* background-color: #9a8c98; */
  width: 100%;
  padding: 7px;
  padding-left: 12px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: 'relative';
  margin-bottom: 5px;
}

.bg {
  padding: 10px;
}

.comment {
  font-size: 20px;
  color: #FFF;
}

.chat-name-bg:hover {
  border: 0px solid rgba(98, 211, 167, 0.00);
  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.00) 100%);
  backdrop-filter: blur(8px);
  /* Adjust the blur value as needed */
  width: 100%;
  border-radius: 12.689px;
}

.delete {
  font-size: 17px;
}

.select-chat-name-text-container {
  width: 80%;
  display: flex;
  height: 30px;
  overflow: hidden;
}

.chat-name-text-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 30px;
  overflow: hidden;
}

.chat-text {
  width: 89%;
}

.edit-delete-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40%;
  height: 100%;
}

.image-container {
  width: 100%;
}

.full-image-container {
  width: 100%;
}

.image {
  width: 90%;
  height: 520px;
}

textarea {
  resize: none !important;
}

textarea::-webkit-scrollbar {
  width: 5px;
  height: 0;
}

textarea::-webkit-scrollbar-thumb {
  background: #9E9FA5;
  height: 5px !important;
}

textarea::-webkit-scrollbar-thumb:hover {
  background: rgb(139, 97, 97);
}

textarea::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 5px;
  height: 5px !important;
}

.error-msg {
  font-size: 17px;
  font-weight: 500;
  color: red;
  float: left;
}

.delete-popup {
  position: fixed;
  top: 0;
  left: 0%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000000001;
  /* Ensure it's on top */
}

.delete-content {
  background-color: white;
  width: 450px;
  padding: 30px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-align: center;
  /* Center the content */
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.popup-buttons {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.table-bordered {
  border-collapse: collapse;
  width: 100%;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: center;
}

.table-bordered th {
  background-color: #c3c1bf;
  /* Header background color */
  color: #fff;
  /* Header text color */
}

.table-bordered tr:nth-child(even) {
  background-color: #f2f2f2;
  /* Even row background color */
}

.table-bordered tr:nth-child(odd) {
  background-color: #e0e0e0;
  /* Odd row background color */
}

.share-icon {
  color: #0664AE;
  font-size: 20px;
}

.share-icon-container {
  /* width: 93.271px; */
  /* height: 37px; */
  flex-shrink: 0;
  border-radius: 12.333px;
  border: 1.5px solid #0664AE;
  cursor: pointer;
  font-size: 0.9vw;
  padding: 5px;
  padding-left: 15px;
  padding-right: 15px;
}
.save-icon-container{
  /* height: 37px; */
  flex-shrink: 0;
  border-radius: 12.333px;
  border: 1.5px solid #0664AE;
  cursor: pointer;
  color: #0664AE;
  padding: 5px;
  padding-left: 15px;
  padding-right: 15px;
}
.cancel-icon-container{
  height: 37px;
  flex-shrink: 0;
  border-radius: 12.333px;
  border: 0.771px solid red;
  cursor: pointer;
  padding-left: 10px;
  padding-right: 10px;
  color: red;
}
.share-icon-container:hover {
  border: 3px solid #0664AE;
}
.save-icon-container:hover{
  border: 3px solid #0664AE;
}
.cancel-icon-container:hover{
  border: 3px solid red;
}
.share-text {
  color: #0664AE;
  font-size: 1vw;
  font-weight: 500;
  margin: 0px;
  margin-left: 3px;
}

.overlay {
  position: fixed;
  top: 0%;
  bottom: 4%;
  left: 0%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  /* Semi-transparent black background */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* z-index: 1234567890987; */
  /* Set a high z-index value */
  z-index: 100000005;
  /* border-radius: 50px; */
}

.share-popup {
  background: #fff;
  /* White background */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  /* Box shadow for a subtle effect */
  text-align: center;
  z-index: 10001;
  width: 500px;
}

.share-content-bg-container {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  border-radius: 0px;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  /* overflow-y: auto;
  padding: 20px;
  position: relative; */
}
.share-bg-container{
  width: 100vw;
  height: 100vh;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
.share-chat-container {
  width: 100%;
  /* height: 90vh; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.share-content-bg-container::-webkit-scrollbar {
  width: 10px !important;
  height: 0;
  border-radius: 5px;
}

.share-content-bg-container::-webkit-scrollbar-thumb {
  background: rgb(215, 215, 217) !important;
  height: 10px !important;
}

.share-content-bg-container::-webkit-scrollbar-thumb:hover {
  background: rgb(139, 97, 97);
}

.share-content {
  width: 70%;
  /* height: 90%; */
}

.sidebar-popup {
  position: absolute;
  top: 10%;
  left: 90%;
  /* Position to the right of the name-container */
  transform: translateX(10px);
  background-color: #bcbec5;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1;
  /* Ensure it's above the content */
  display: flex;
  align-items: center;
}

.arrow-down {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
  left: -15px;
  border-width: 0 10px 10px 10px;
  border-style: solid;
  border-color: transparent transparent #9E9FA5 transparent;
}

.popup-content {
  white-space: nowrap;
  /* Prevent content from wrapping */
}

.pin-icon-container {
  border: 1px solid black;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.pin-icon-container-active {
  /* border: 1px solid rgb(7, 94, 131); */
  border-radius: 5px;
  padding: 7px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /* background-color: #f9f9f9; */
  /* margin-bottom: 5px; */
}

.pin-icon {
  color: #fff;
  font-size: 15px;
  cursor: pointer;
}

.pin-icon-active {
  color: #fff;
  font-size: 15px;
  /* cursor: pointer; */
}

.pin-popup-container {
  width: 100%;
  max-width: 350px;
  background-color: #022636;
  padding: 30px;
  border-radius: 10px;
  width: 25%;
  z-index: 100001;
  position: fixed;
  top: 30%;
  left: 40%;
  transition: opacity 0.3s ease, visibility 0.3s ease; 
}

.dashboard-input {
  padding: 7px;
  padding-left: 10px;
  font-size: 14px;
  border: 1px solid #9E9FA5;
  border-radius: 5px;
  width: 72%;
}

.dashboard-button {
  padding: 7px;
  margin-left: 5px;
  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));
  border-radius: 5px;
  border-style: none;
  color: #f9f9f9;
  width: 28%;
}

.horizontal-line {
  color: rgb(182, 182, 185);
}

.empty-dashboard-container {
  width: 100%;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dashboard-name-container {
  background-color: #EBE4D1;
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.dashboard-name {
  margin: 0px;
}

.down-arrow {
  margin-top: 0px;
}
.dashboard-card-container{
  border-radius: 15px;
  box-shadow: 0px 3.09px 3.09px 0px rgba(0, 0, 0, 0.25);
  /* overflow: auto; */
  display: flex;
  flex-direction: column;
}
.dashboard-query-container {
  /* border-top: 86.514px solid var(--Gradient, #2C7B74); */
  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px;
}

.dashboard-query-text-container {
  flex-grow: 1;
  margin-right: 10px;
}
.summary-text{
  color: #fff;
}
.dashboard-result-container {
  background-color: #FCFCFC;
  height: 100%;
}

.dashboard-response-text-container {
  width: 100%;
  position: "relative"
}

.loader {
  border: 8px solid #f3f3f3;
  /* Light grey */
  border-top: 8px solid #3498db;
  /* Blue color */
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.responsive-grid-layout {
  /* margin: 16px; */
  position: relative;
}

.layout {
  overflow: hidden;
  min-height: 95vh;
}

.react-grid-item {
  /* background-color: #E4F1FF; */
  border-radius: 10px;
  color: black;
  text-align: center;
  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px;
  transition: all 0.3s ease-in-out;

  /* Initially hide the overflow to avoid content showing before hover */
  overflow: hidden;

  /* Add shadow for a lifting effect */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    /* Change lifting effect color to peacock violet */
    /* box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px; */
  }
}




/* Add media queries for responsiveness */
@media (max-width: 1200px) {
  .react-grid-item {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .react-grid-item {
    font-size: 12px;
  }
}

.dashboard-bg-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dashboard-content-container {
  height: 90%;
  width: 100%;
  overflow-y: auto;
  padding: 30px;
  position: relative;
  margin-bottom: 30px;
}

.dashboard-summary {
  color: black;
  font-size: 20px;
  font-weight: bold;
}

.dashboard-result {
  color: rgb(144, 100, 144);
  font-size: 20px;
  font-weight: bold;
}

.column-header-style {
  font-weight: bold;
  color: black;
}

#myGrid1 .ag-header.ag-pivot-off {
  /* background: #176B87; */
  color: #fff;
  font-weight: bolder;
  font-size: 0.95vw;
}
.chart-filter-container{
  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));
  padding: 20px;
  border-radius: 20px;
}
.schedule-icon{
  color: #0664AE;
  font-size: 30px;
  margin-right: 20px;
  cursor: pointer;
}
.cron-schedule-container{
  background-color: #fff;
  border-radius: 10px;
  /* padding: 30px; */
  width: 70%;
  max-width: 790px;
  z-index: 100001;
  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset; */
  /* animation: slide-in-blurred-tr 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both; */
}

@keyframes slide-in-blurred-tr {
  0% {
    transform: translate(1000px, -1000px) skew(-80deg, -10deg);
    transform-origin: 0% 0%;
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    transform: translate(0, 0) skew(0deg, 0deg);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
}
.hide-cron {
  background-color: #f9f9f9;
  border-radius: 20px;
  padding: 30px;
  width: 590px;
  /* position: fixed;
  top: 30%;
  left: 23%; */
  z-index: 1001;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  animation: slide-out-blurred-tr 0.45s cubic-bezier(0.755, 0.050, 0.855, 0.060) both;
}

@keyframes slide-out-blurred-tr {
  0% {
    transform: translate(0, 0) skew(0deg, 0deg);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
  100% {
    transform: translate(1000px, -1000px) skew(-80deg, -10deg);
    transform-origin: 0% 0%;
    filter: blur(40px);
    opacity: 0;
  }
}
.cron-container{
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.mic-button {
  flex-shrink: 0;
}

@keyframes pulse {
  0%, 100% {
      transform: scale(1);
      color: red;
  }
  50% {
      transform: scale(1.2);
      color: blue;
  }
}

.listening {
  animation: pulse 1s infinite;
}
.rainbow-transition {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: linear-gradient(to right, violet, indigo, blue, green, yellow, orange, red);
  background-size: 200% 200%;
  animation: rainbow-animation 3s infinite;
}

@keyframes rainbow-animation {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
}
.recommendations-container {
  width: 80%;
  background: rgba(243, 247, 247, 0.67);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(7.4px);
  -webkit-backdrop-filter: blur(7.4px);
  border: 1px solid rgba(243, 247, 247, 0.32);
  position: absolute;
  bottom: 100%;
  overflow-y: hidden;
  margin-bottom: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  z-index: 100001;
}
.recommendation-container{
  font-weight: 500;
  font-size: 15px;
  color: #4d4b4b;
  display: flex;
  align-items: center;
  padding: 10px;
  padding-left: 20px;
}
.recommendation-container:hover{
  /* From https://css.glass */
background: rgba(47, 104, 130, 0.47);
color: #fff;
box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
backdrop-filter: blur(7.1px);
-webkit-backdrop-filter: blur(7.1px);
border-left: 5px solid #022636;
}
.cron-schedule-close-icon-container{
  position: absolute;
  padding: 3px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 50%;
  background-color: #d1e7f1;
  left: 90%;
  top: 5%;
  cursor: pointer;
}
.schedule-button{
  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));
  padding: 7px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
  border-width: 0px;
  color: #f9f9f9;
  font-size: 15px;
}
.selected-popup-bg-container {
  /* background-color: blue; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 41%;
  height: 59%;
  /* max-width: 1000px;
  max-height: 450px; */
  border-radius: 30px;
  /* box-shadow: 0px 3.09px 3.09px 0px rgba(0, 0, 0, 0.25); */
  display: flex;
  flex-direction: column;
  opacity: 0; /* Set initial opacity to 0 */
  z-index: 1000000000000009;
  animation: scale-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  /* transform: translate(-30%, -30%); */
}
.selected-popup-bg-container.scale-out {
  animation: scale-out-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}
.selected-popup-bg-container.scale-in-top-left {
  animation: scale-in-top-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
.selected-popup-bg-container.scale-in-top-right {
  animation: scale-in-top-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
.selected-popup-bg-container.scale-in-bottom-left {
  animation: scale-in-bottom-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
.selected-popup-bg-container.scale-in-bottom-right {
  animation: scale-in-bottom-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
.selected-popup-bg-container.scale-out-top-left {
  animation: scale-out-top-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}
.selected-popup-bg-container.scale-out-top-right {
  animation: scale-out-top-right 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}
.selected-popup-bg-container.scale-out-bottom-left {
  animation: scale-out-bottom-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}
.selected-popup-bg-container.scale-out-bottom-right {
  animation: scale-out-bottom-right 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}
@keyframes scale-in-top-left {
  0% {
    transform: scale(0) translate(-100%, -100%);
    opacity: 1;
  }
  100% {
    transform: scale(1) translate(0%, 0%);
    opacity: 1;
  }
}

@keyframes scale-out-top-left {
  0% {
    transform: scale(1) translate(0%, 0%);
    opacity: 1;
  }
  100% {
    transform: scale(0) translate(-100%, -100%);
    opacity: 1;
  }
}

@keyframes scale-in-top-right {
  0% {
    transform: scale(0) translate(100%, -100%);
    opacity: 1;
  }
  100% {
    transform: scale(1) translate(0%, 0%);
    opacity: 1;
  }
}

@keyframes scale-out-top-right {
  0% {
    transform: scale(1) translate(0%, 0%);
    opacity: 1;
  }
  100% {
    transform: scale(0) translate(100%, -100%);
    opacity: 1;
  }
}

@keyframes scale-in-bottom-left {
  0% {
    transform: scale(0) translate(-100%, 100%);
    opacity: 1;
  }
  100% {
    transform: scale(1) translate(0%, 0%);
    opacity: 1;
  }
}
/* .ag-theme-balham .ag-filter-select .ag-filter-checkbox {
  color: black !important;
} */
@keyframes scale-out-bottom-left {
  0% {
    transform: scale(1) translate(0%, 0%);
    opacity: 1;
  }
  100% {
    transform: scale(0) translate(-100%, 100%);
    opacity: 1;
  }
}

@keyframes scale-in-bottom-right {
  0% {
    transform: scale(0) translate(100%, 100%);
    opacity: 1;
  }
  100% {
    transform: scale(1) translate(0%, 0%);
    opacity: 1;
  }
}

@keyframes scale-out-bottom-right {
  0% {
    transform: scale(1) translate(0%, 0%);
    opacity: 1;
  }
  100% {
    transform: scale(0) translate(100%, 100%);
    opacity: 1;
  }
}
.file-icon{
  font-size: 25px;
  color: black;
  margin-right: 10px;
  cursor: pointer;
  margin-bottom: 17px;
}


.transition-page-container{
  width: 100%;
  height: 100%;
  background-color: transparent;
  /* margin-left: 15px; */
  /* padding: 50px; */
  /* display: flex; */
  /* flex-wrap: wrap; */
  /* justify-content: center; */
  /* align-items: center; */
}
.transition-card-container{
  border-radius: 10px;
  /* width: 300px; */
  height: 200px;
  display: flex;
  align-items: flex-end;
  /* padding: 20px; */
  /* margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 10px; */
  cursor: pointer;
}


.container-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  width: 100%;
  transition: transform 0.5s ease-in-out; /* Adding smooth animation */
}

.slide-in-left {
  animation: slideInLeft 0.5s forwards;
}

.slide-out-left {
  animation: slideOutLeft 0.5s forwards;
}

@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideOutLeft {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-100%);
  }
}

.slide-in-right {
  animation: slideInRight 0.5s forwards;
}

.slide-out-right {
  animation: slideOutRight 0.5s forwards;
}

@keyframes slideInRight {
  0% {
    opacity: 0;
    transform: translateX(100%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideOutRight {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(100%);
  }
}


.user-details-popup-container{
  position: absolute;
  /* background-image: url("../../assets/images/Rectangle 10.png");
  background-repeat: no-repeat;
  background-size: cover; */
  background-image: linear-gradient(to right, #233f4b, #538aa0);
  bottom: 67%;
  width: 80%;
  z-index: 1000001;
  border-radius: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding: 10px;
  right: 10%;
}
.IaE-user-details-popup-container{
  position: absolute;
  /* background-image: url("../../assets/images/Rectangle 10.png");
  background-repeat: no-repeat;
  background-size: cover; */
  background-image: linear-gradient(to right, #233f4b, #538aa0);
  bottom: 140%;
  width: 80%;
  z-index: 1000001;
  border-radius: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding: 10px;
  right: 10%;
}
.user-details-item-container{
  background-color: transparent;
  width: 100%;
  padding: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  text-decoration: none;
}
.user-details-item-container:hover {
  border: 0px solid rgba(98, 211, 167, 0.00);
  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.00) 100%);
  backdrop-filter: blur(8px);
  /* Adjust the blur value as needed */
  width: 100%;
  border-radius: 12.689px;
}
.react-grid-layout-resize-handle {
  /* Increase the width and height to your desired size */
  width: 20px;
  height: 20px;

  /* Add any other styles you need */
}

/* Additional styles for the hover state (optional) */
.react-grid-layout-resize-handle:hover {
  /* Add hover styles if needed */
  width: 40px;
  height: 40px;
}
.typewriter {
  overflow: hidden;
  border-right: 0.15em solid orange;
  white-space: nowrap;
  margin: 0 auto;
  letter-spacing: 0.15em;
  animation:
    typewriterAnimation 3.5s steps(40, end),
    blink-caret 0.75s step-end infinite;
}

@keyframes typewriterAnimation {
  from { width: 0 }
  to { width: 100% }
}

@keyframes blink-caret {
  from, to { border-color: transparent }
  50% { border-color: orange; }
}
.cron-menu-item{
  padding: 20px;
  font-weight: bold;
  padding-top: 5px;
  padding-bottom: 5px;
  /* border-radius: 20px; */
  color: #000;
  cursor: pointer;
}
.cron-menu-item-selected{
  background-color: rgb(7, 94, 131);
  color: #f9f9f9;
}
.popup-overlay {
  position: absolute;
  top: 0;
  left: 19%;
  width: 81%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.text-color{
  color: rgb(7, 94, 131);
}
.sub-text-color{
  color: grey;
}
.flip-horizontal-bottom {
  animation: flip-horizontal-bottom 0.4s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
}

@keyframes flip-horizontal-bottom {
  0%, 100% {
    transform: rotateX(0);
  }
  50% {
    transform: rotateX(90deg);
  }
}
.new-toggle-button{
  background-color: transparent;
  border-width: 0px;
  padding: 10px;
  padding-left: 20px;
}
.new-select-toggle-button{
  background-color: lightgrey;
  border-radius: 30px;
}


.custom-button-style {
  /* margin-right: 50px; */
  /* margin-bottom: 45px; */
  display: inline-block;
  outline: 0;
  border: 0;
  border-radius: 6px; /* Keep the radius consistent */
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.15s ease; /* Transition should only be declared once */
  will-change: box-shadow, transform;
  background: #FCFCFD;
  /* box-shadow: 
    0px 2px 4px rgb(45 35 66 / 40%), 
    0px 7px 13px -3px rgb(45 35 66 / 30%), 
    inset 0px -3px 0px #d6d6e7; */
  /* height: 48px; */
  padding: 10px 19px 10px 19px;
  font-size: 1vw;
  color: #36395a;
  font-weight: 600;
  text-decoration: none;
  text-align: center;
  background-color: #e9f0f7;
}

.custom-button-style:hover {
  box-shadow: 
    0px 4px 8px rgb(45 35 66 / 40%), 
    0px 7px 13px -3px rgb(45 35 66 / 30%), 
    inset 0px -3px 0px #d6d6e7;
}

.custom-button-style:active {
  box-shadow: inset 0px 3px 7px #d6d6e7;
  transform: scale(0.98); /* Add a subtle scale effect on click */
}

@keyframes zoomIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.zoom-in {
  animation: zoomIn 0.5s ease-in-out;
}

.font-bold {
  font-weight: 600;
}
.tooltiptext{
  visibility: hidden;
  width: 150px;
  background-color: #125B9A;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 13%;
  left: 250%;
  margin-left: -50px;
  opacity: 0;
  transition: opacity 0.3s;
}
.scrollable-container {
  overflow-y: overlay; /* Scrollbar overlays content without occupying space */
  /* position: relative; */
  /* right: 0; */
  /* background-color: blue; */
}

.scrollable-container::-webkit-scrollbar {
  overflow-y: overlay; /* Scrollbar overlays content without occupying space */
  position: absolute; /* Ensures the container itself is properly positioned */
  right: 0;
  width: 10px; /* Adjust the scrollbar width */
  /* background-color: blue; */
}

.scrollable-container::-webkit-scrollbar-thumb {
  background: lightgrey; /* Thumb styling for visibility */
  border-radius: 4px; /* Rounded scrollbar thumb */
}

.scrollable-container::-webkit-scrollbar-track {
  background-color: transparent; /* Ensures track is fully transparent */
}

.scrollable-container::-webkit-scrollbar-track-piece {
  background-color: transparent; /* Consistent transparency across all browsers */
}
.react-select__menu {
  z-index: 1050; /* Adjust based on your application's layers */
}
.react-select__control {
  all: unset; /* Optional: Resets inherited styles */
  border: 1px solid #ccc;
  border-radius: 4px;
}
.custom-select {
  max-height: 150px; /* Adjust the height as needed */
  overflow-y: auto; /* Adds scroll if content exceeds the height */
  width: 100%; /* Ensures full width of the parent */
  box-sizing: border-box; /* Ensures padding is included in width */
}

/* Optional: For a better look */
.custom-select option {
  padding: 8px; /* Adds padding to options */
}
/* Wrapper for the tooltip container */
.tooltip-container {
  /* position: relative; */
  /* display: inline-block; */
  /* width: 100%; */
}

/* Button or icon that triggers the tooltip */
.tooltip-trigger {
  cursor: pointer;
  font-size: 1vw;
  /* background-color: transparent; */
  /* border: 1px solid #ccc; */
  /* border-radius: 5px; */
  /* padding: 10px; */
  /* transition: background-color 0.3s ease; */
  width: 100%;
}

.tooltip-trigger:hover {
  /* background-color: #f0f0f0; */
}

/* Tooltip itself */
.tooltip-text {
  visibility: hidden; /* Initially hidden */
  /* width: 190px; */
  background-color: black; /* Background color of the tooltip */
  color: #fff; /* Text color */
  text-align: center; /* Centers the text inside */
  border-radius: 7px;
  padding: 5px 19px 5px 19px;
  position: absolute;
  z-index: 1; /* Ensures it appears above other elements */
  opacity: 0; /* Initially invisible */
  transition: opacity 0.3s ease-in-out; /* Fade-in effect */
  font-size: 14px; /* Smaller text size */
  white-space: nowrap; /* Prevents the text from wrapping */
  max-width: 200px; /* Optional: Set a max width if needed */
  width: auto; /* Ensure the width is auto to fit the text length */
}
.tooltip-text.top {
  left: 50%;
  top: 0%;
  transform: translateX(-50%) translateY(-119%);
}
.tooltip-text.left {
  bottom: 50%;
  left: 0%;
  transform: translateX(-110%) translateY(50%);
}
.tooltip-text.bottom {
  top: 100%;
  left: 0%;
  transform: translateX(-41.5%) translateY(50%);
}
.tooltip-text.right {
  top: 50%;
  left: 130%;
  transform: translateY(-50%);
}

/* When hovering over the tooltip container, show the tooltip */
.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1; /* Make the tooltip visible */
}

/* Tooltip Arrow styling */
.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-width: 5px;
  border-style: solid;
  border-color: transparent;
}

.tooltip-arrow.top {
  bottom: -9px;
  left: 50%;
  transform: translateX(-50%);
  border-top-color: black;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.tooltip-arrow.bottom {
  top: 0%;
  left: 50%;
  transform: translateX(-50%) translateY(-100%);
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: black;
}
.tooltip-arrow.left {
  top: 50%;
  left: 100%;
  transform: translateX(-0%) translateY(-50%);
  border-top-color: transparent;
  border-left-color: black;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.tooltip-arrow.right {
  top: 50%;
  left: 0%;
  transform: translateX(-110%) translateY(-50%);
  border-top-color: transparent;
  border-left-color: transparent;
  border-right-color: black;
  border-bottom-color: transparent;
}




.popup-overlay-settings {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(78, 77, 77, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.dropdown-container {
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
  width: 300px;
  /* margin: auto; */
}
.disabled {
  pointer-events: none; /* Prevents any interaction with the div */
  opacity: 0.5; /* Reduces opacity to indicate it's disabled */
  cursor: not-allowed;
}


.dropdown {
  position: relative;
}

.dropdown-button {
  width: 100%;
  padding: 10px;
  background-color: #fff;
  color: #000;
  border: 1px solid lightgrey;
  cursor: pointer;
  border-radius: 5px;
  text-align: left;
}

.dropdown-button:hover {
  /* background-color: #0056b3; */
}

.dropdown-heading {
  width: 100%;
  padding: 10px;
  background-color: #fff;
  color: #000;
  border: 1px solid lightgrey;
  cursor: pointer;
  border-radius: 0px;
  text-align: left;
}

.new-dropdown-menu {
  position: absolute;
  width: 100%;
  background: white;
  border: 1px solid #ddd;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
}

.new-dropdown-item {
  padding: 10px;
  cursor: pointer;
}

.new-dropdown-item:hover {
  background-color: #f1f1f1;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.confirm-button {
  padding: 10px;
  background-color: #28a745;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  width: 100%;
}

.confirm-button:hover {
  background-color: #218838;
}

.result-box {
  background: #f8f9fa;
  padding: 10px;
  border-radius: 5px;
  font-size: 14px;
  white-space: pre-wrap;
}

.restricted-content{
  font-size: 14px;
  table-layout: fixed;
  width: 100%;
}
.restricted-content h1,
.restricted-content h2,
.restricted-content h3,
.restricted-content h4,
.restricted-content h5,
.restricted-content h6,
/* .restricted-content strong, */
.restricted-content b {
  display: inline !important;
  font-size: 15px !important;
  font-weight: bold !important; /* Optional: remove bold effect */
} 
.restricted-content strong {
  display: inline !important;
  font-size: 14px !important;
  font-weight: 600 !important; /* Optional: remove bold effect */
} 
.restricted-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 14px;
  table-layout: auto;
  overflow-x: auto;
  display: block;
  border: 1px solid #efefef; /* Outer border */
  border-radius: 4px; /* Optional: rounded corners */
}

.restricted-content th,
.restricted-content td {
  border: 1px solid #efefef;
  padding: 10px 14px;
  text-align: center;
  vertical-align: center;
  font-size: 14px !important;
}
.restricted-content th{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 170px;
  max-width: 250px;
}
.restricted-content td {
  /* max-width: 250px; */
  word-wrap: break-word;     /* allow long words to break */
  white-space: normal;       /* allow line breaks */
  overflow-wrap: anywhere;   /* modern fallback */
}


.restricted-content thead {
  background-color: #f2f2f2;
}

.restricted-content tbody tr:nth-child(even) {
  /* background-color: #e4d1d1; */
}

.restricted-content tbody tr:hover {
  background-color: #f9f9f9;
}


.restricted-content tbody tr {
  border: 1px solid #eaeaea;
}

/* Optional: make table scrollable on small screens */
.restricted-content table {
  overflow-x: auto;
  display: block;
  white-space: nowrap;
}
.restricted-content li {
  font-size: 14px !important;
  font-weight: normal !important; /* Optional: remove bold effect */
  margin-top: 5px;
} 
.restricted-content td.matched {
  background-color: rgb(190, 249, 190, 0.3);
} 
.restricted-content td.discrepancy {
  background-color: rgba(253, 199, 204, 0.3);
} 
.restricted-content td.missing {
  background-color: rgba(253, 199, 204, 0.3);
} 

.gpt-response h1, 
.gpt-response h2, 
.gpt-response h3 {
  margin-top: 1rem;
  font-weight: 600;
  font-size: 17px;
}

.gpt-response p {
  margin-bottom: 0.75rem;
  line-height: 1.6;
  font-size: 15px;
}

.gpt-response strong {
  /* margin-bottom: 0.75rem; */
  /* line-height: 1.6; */
  font-size: 15px;
  font-weight: 600;
  display: inline;
}

.gpt-response ul {
  padding-left: 1.2rem;
  margin-bottom: 1rem;
  font-size: 15px;
}

.gpt-response li {
  margin-bottom: 0.5rem;
  font-size: 15px;
  /* list-style-type: circle; */
}

.gpt-response code {
  background: #f8f9fa;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-family: monospace;
  font-size: 15px; 
}
.hover-container {
               /* darker text */
}
.hover-container:hover {
  background-color: #e9e9e9;   /* subtle darker bg */
  border-color: #bbb;          /* darker border */
  transform: scale(1.03);      /* slight zoom */
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15); /* shadow pop */
  color: #333;                 /* darker text */
}
/* Left section gradient */
.left-section {
  background: linear-gradient(to bottom, rgb(14,88,214, 0.1), rgb(14,88,214,0.05));;
}

/* Marquee */
.marquee-container {
  height: 350px;
  width: 500px;
}

.marquee {
  display: flex;
  animation: marquee 10s linear infinite;
}

@keyframes marquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

/* Org card */
.org-card {
  width: 270px;
  height: 200px;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.org-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}
/* Continuous expand & shrink pulse */
@keyframes pulse-breath {
  0%, 100% {
    transform: scale(0.3);
    opacity: 0.6;
  }
  50% {
    transform: scale(6); /* expand bigger */
    opacity: 0.3;          /* fade slightly */
  }
}

.pulse-ring {
  position: absolute;
  border-radius: 50%;
  animation: pulse-breath 2.5s infinite ease-in-out;
}
.wave {
  width: 0.5rem;
  background-color: #0d6efd; /* Bootstrap primary */
  border-radius: 0.25rem;
  transform-origin: center; /* expand from center */
  transition: transform 0.1s ease; /* smooth scaling */
}
.recording-container {
  position: relative;
  width: 180px;
  height: 180px;
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.mic-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 36px;
  z-index: 5;
}

/* Rings */
.pulse-ring {
  position: absolute;
  border-radius: 50%;
  /* animation: pulse 2s infinite; */
  opacity: 0.6;
}

.ring1 {
  width: 105px;
  height: 105px;
  background: rgba(13, 110, 253, 0.2);
  animation-delay: 0s;
}
.ring2 {
  width: 75px;
  height: 75px;
  background: rgba(13, 110, 253, 0.3);
  animation-delay: 0.3s;
}
.ring3 {
  width: 45px;
  height: 45px;
  background: rgba(13, 110, 253, 0.4);
  animation-delay: 0.6s;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.3);
    opacity: 0.3;
  }
  100% {
    transform: scale(0.9);
    opacity: 0.7;
  }
}

/* Bars */
.bars-container {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 6px;
  height: 80px;
  margin-top: 20px;
}

.bar {
  width: 8px;
  background-color: #0d6efd;
  border-radius: 4px;
  animation: wave 1s ease-in-out infinite;
  transform-origin: center;
}

@keyframes wave {
  0%, 100% {
    transform: scaleY(0.6);
  }
  50% {
    transform: scaleY(1.3);
  }
}

/* Transcript box */
.transcript-box {
  background: rgba(240, 240, 240, 0.9);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.restricted-content{
  font-size: 1vw;
  width: 100%;
  flex-grow: 1;
}
.restricted-content h1,
.restricted-content h2,
.restricted-content h3,
.restricted-content h4,
.restricted-content h5,
.restricted-content h6,
/* .restricted-content strong, */
.restricted-content b {
  display: inline !important;
  font-size: 1.1vw !important;
  font-weight: bold !important; /* Optional: remove bold effect */
} 
.restricted-content strong {
  display: inline !important;
  font-size: 1vw !important;
  font-weight: 600 !important; /* Optional: remove bold effect */
} 
/* .restricted-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 1em 0;
  font-size: 1vw;
  display: block;
  border: 2px solid #efefef;
  border-radius: 4px;
} */

.restricted-content th,
.restricted-content td {
  border: 1px solid #efefef;
  padding: 0.7vw 0.95vw;
  text-align: left;
  vertical-align: center;
  font-size: 0.9vw !important;
}


.restricted-content thead {
  background-color: #f2f2f2;
}

.restricted-content tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.restricted-content tbody tr:hover {
  background-color: #f0f0f0;
}


.restricted-content li {
  font-size: 0.9vw !important;
  font-weight: normal !important; /* Optional: remove bold effect */
  margin-top: 5px;
} 
.restricted-content td.matched {
  background-color: rgb(190, 249, 190, 0.3);
} 
.restricted-content td.discrepancy {
  background-color: rgba(253, 199, 204, 0.3);
} 
.restricted-content td.missing {
  background-color: rgba(253, 199, 204, 0.3);
} 


.custom-table-style table {
  width: 100%;
  height: 100%;
  table-layout: auto;
  border-collapse: collapse;
  margin: 0;
  font-size: 1vw;
  overflow-x: auto;
  /* display: block; */
  white-space: normal;
  border: 0px solid #efefef;
  border-radius: 4px;
}

.custom-table-style th,
.custom-table-style td {
  padding: 0.3vw 0.5vw;
  text-align: left;
  vertical-align: center;
  font-size: 0.9vw !important;
  /* white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere; */
  border: 1px solid #efefef;
  font-weight: 500;
  text-align: center;
}

.custom-table-style th {
  /* white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; */
  font-weight: bold;
  font-size: 1vw !important;
  padding: 0.75vw 0.5vw;
  background-color: lightgrey;
  padding: 0.3vw 0.5vw;
  border: 0px solid #efefef;
}

.custom-table-style thead {
  background-color: #f2f2f2;
  font-weight: bold;
}

.custom-table-style tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.custom-table-style tbody tr:hover {
  background-color: #f0f0f0;
}

.custom-table-style td.matched {
  background-color: rgba(190, 249, 190, 0.3);
}

.custom-table-style td.discrepancy,
.custom-table-style td.missing {
  background-color: rgba(253, 199, 204, 0.3);
}


.restricted-content{
  font-size: 1vw;
  table-layout: fixed;
  width: 100%;
}
.restricted-content h1,
.restricted-content h2,
.restricted-content h3,
.restricted-content h4,
.restricted-content h5,
.restricted-content h6,
/* .restricted-content strong, */
.restricted-content b {
  display: inline !important;
  font-size: 1.1vw !important;
  font-weight: bold !important; /* Optional: remove bold effect */
} 
.restricted-content strong {
  display: inline !important;
  font-size: 1vw !important;
  font-weight: 600 !important; /* Optional: remove bold effect */
} 
.restricted-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  font-size: 1vw;
  table-layout: auto;
  overflow-x: auto;
  /* display: block; */
  border: 0px solid #efefef; /* Outer border */
  border-radius: 4px; /* Optional: rounded corners */
}

.restricted-content th,
.restricted-content td {
  border: 1px solid #efefef;
  padding: 0.7vw 0.95vw;
  text-align: left;
  vertical-align: top;
  font-size: 0.9vw !important;
  min-width: 13vw;
  max-width: 17vw;
}
.restricted-content th{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border: 0px solid #efefef;
}
.restricted-content td {
  /* max-width: 250px; */
  word-wrap: break-word;     /* allow long words to break */
  white-space: normal;       /* allow line breaks */
  overflow-wrap: anywhere;   /* modern fallback */
}


.restricted-content thead {
  background-color: #f2f2f2;
}

.restricted-content tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.restricted-content tbody tr:hover {
  background-color: #f0f0f0;
}

/* Optional: make table scrollable on small screens */
.restricted-content table {
  overflow-x: auto;
  /* display: block; */
  white-space: nowrap;
}
.restricted-content li {
  font-size: 0.9vw !important;
  font-weight: normal !important; /* Optional: remove bold effect */
  margin-top: 0.35vw;
} 
.restricted-content td.matched {
  background-color: rgb(190, 249, 190, 0.3);
} 
.restricted-content td.discrepancy {
  background-color: rgba(253, 199, 204, 0.3);
} 
.restricted-content td.missing {
  background-color: rgba(253, 199, 204, 0.3);
} 
.restricted-content thead,
.restricted-content tfoot {
  background-color: #f2f2f2;
  z-index: 10;
}
.upload-btn-1{
  color: rgb(14, 88, 214)!important;
  padding: 0.19vw 0.7vw!important;
  border-radius: 0.3vw!important;
}
.upload-btn-1:hover{
  color: #f9f9f9!important;
}
.restricted-content tfoot {
  background-color: #eaeaea;
}
.sticky-col-1 {
  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  z-index: 3;
  /* min-width: 150px; */
}

.sticky-col-2 {
  position: sticky;
  left: 0px; /* width of previous column */
  right: 0;
  background-color: #f9f9f9;
  z-index: 3;
  /* min-width: 150px; */
}
.sticky-col-3 {
  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  z-index: 3;
  /* min-width: 150px; */
}
.ai-loader {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: radial-gradient(circle, #0e58d6 35%, transparent 25%);
  animation: pulse 1.5s infinite ease-in-out;
  margin: auto;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
}
.success-checkmark {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: inline-block;
  border: 4px solid #4caf50;
  position: relative;
  box-sizing: content-box;
}

.check-icon {
  width: 100px;
  height: 100px;
  position: relative;
}

.icon-line {
  height: 5px;
  background-color: #4caf50;
  display: block;
  border-radius: 2px;
  position: absolute;
  transform-origin: left;
}

.line-tip {
  width: 25px;
  top: 50px;
  left: 28px;
  transform: rotate(45deg);
  animation: tip 0.3s ease-out forwards;
}

.line-long {
  width: 47px;
  top: 45px;
  left: 28px;
  transform: rotate(-45deg);
  animation: long 0.3s ease-out 0.3s forwards;
}

.icon-circle {
  top: -4px;
  left: -4px;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 4px solid rgba(76, 175, 80, 0.5);
  position: absolute;
  box-sizing: content-box;
}

@keyframes tip {
  0% { width: 0; left: 28px; top: 50px; }
  100% { width: 25px; left: 28px; top: 50px; }
}

@keyframes long {
  0% { width: 0; left: 28px; top: 45px; }
  100% { width: 47px; left: 28px; top: 45px; }
}
.checkmark-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}

.check-icon {
  width: 100px;
  height: 100px;
  position: relative;
}

.icon-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 5px solid #4caf50;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  animation: circle-scale 0.6s ease-out forwards;
}

.ellipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;       /* or inline-block */
  width: 100%;          /* or a fixed px value like 150px */
}


.icon-line {
  height: 5px;
  background-color: #4caf50;
  display: block;
  border-radius: 2px;
  position: absolute;
  transform-origin: left;
}

.line-tip {
  width: 0;
  top: 50px;
  left: 26px;
  transform: rotate(45deg);
  animation: draw-tip 0.3s ease-out 0.3s forwards;
}

.line-long {
  width: 0;
  top: 50px;
  left: 26px;
  transform: rotate(0deg);
  animation: draw-long 0.3s ease-out 0.6s forwards;
}

/* Keyframes */
@keyframes circle-scale {
  0% { transform: scale(0.8); opacity: 0.5; }
  100% { transform: scale(1); opacity: 1; }
}

@keyframes draw-tip {
  0% { width: 0; }
  100% { width: 25px; }
}

@keyframes draw-long {
  0% { width: 0; }
  100% { width: 47px; }
}
.excel-table table {
  border-collapse: collapse;
  width: 100%;
  font-family: Arial, sans-serif;
  font-size: 14px;
  color: #1e293b;
}

.excel-table th {
  background: #f1f5f9;
  font-weight: bold;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  text-align: left;
}

.excel-table td {
  padding: 6px 10px;
  border: 1px solid #e2e8f0;
  min-width: 150px;
}

.excel-table tr:nth-child(even) {
  background: #f9fafb;
}

.excel-table tr:hover {
  background: #e0f2fe;
}

.file-grid.ag-theme-balham .ag-cell {
  display: flex;
  justify-content: center;
  align-items: center;   /* vertical centering */
  font-weight: 500;
}
.file-grid.ag-theme-balham .ag-header-cell-label {
  justify-content: center;   /* horizontal center */
  align-items: center;       /* vertical center */
  display: flex;             /* required */
  font-weight: bold;
  color: #000;
  font-size: 14px;
  /* background-color: blue; */
}
.rs-picker-popup {
  z-index: 99999 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/saira.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mFAAmF;AACrF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C;;;;;IAKE;AACJ,qCAAqC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;;AAEpB;;AAEA;EACE,4EAA4E;EAC5E,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mFAAmF;AACrF;AACA;EACE,UAAU;EACV,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,kBAAkB,EAAE,gCAAgC;EACpD,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB,EAAE,wDAAwD;AAC/E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mEAAmE;EACnE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yDAA6D;EAC7D,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,0CAA0C;EAC1C,oHAAoH;EACpH,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;AAEH;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,8EAA8E;EAC9E,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,oHAAoH;EACpH,yCAAyC;EACzC,mEAAmE;EACnE,aAAa;EACb,WAAW;EACX;wBACsB;AACxB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,0CAA0C;EAC1C,oHAAoH;EACpH,yCAAyC;EACzC,mEAAmE;EACnE,aAAa;EACb,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yDAAkE;EAClE,4BAA4B;EAC5B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,WAAW;EACX,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,8EAA8E;EAC9E,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,8EAA8E;EAC9E,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;KAyBK;AACL;EACE,0BAA0B;EAC1B,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kDAAkD;EAClD,UAAU;EACV,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;EACV,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,uDAAuD;EACvD,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;EACnB,wCAAwC;EACxC;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,6CAA6C;EAC7C,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,gDAAgD;EAChD,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;;EAErD,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;;EAEX;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;;IAEjB;MACE,eAAe;MACf,gBAAgB;MAChB,0BAA0B;IAC5B;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;;EAEvC;IACE,gBAAgB;IAChB,eAAe;;IAEf;MACE,kBAAkB;MAClB,gBAAgB;;MAEhB;QACE,eAAe;QACf,kBAAkB;QAClB,WAAW;QACX,SAAS;MACX;;MAEA;QACE,aAAa;QACb,8BAA8B;;QAE9B;UACE,cAAc;UACd,kCAAkC;QACpC;MACF;;MAEA;QACE,gBAAgB;;QAEhB;UACE,gBAAgB;QAClB;MACF;;MAEA,4BAA4B;MAC5B;QACE;UACE,WAAW;UACX,eAAe;UACf,cAAc;QAChB;;QAEA;UACE,aAAa;QACf;;QAEA,+BAA+B;QAC/B;UACE,kBAAkB;UAClB,yBAAyB;UACzB,kBAAkB;UAClB,gBAAgB;UAChB,qBAAqB;UACrB,YAAY;UACZ,iBAAiB;UACjB,gBAAgB;UAChB,sBAAsB;UACtB,WAAW;UACX,iBAAiB;UACjB,eAAe;UACf,kBAAkB;QACpB;;QAEA,uBAAuB;QACvB;UACE,qBAAqB;QACvB;;QAEA,wBAAwB;QACxB;UACE,yBAAyB;UACzB,kCAAkC;UAClC,qBAAqB;UACrB,kCAAkC;UAClC,WAAW;UACX,kCAAkC;QACpC;MACF;IACF;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;EACF;;EAEA;;IAEE,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,6BAA6B;IAC7B,+BAA+B;;IAE/B,kCAAkC;IAClC,qGAAqG;IACrG,gCAAgC;IAChC,uCAAuC;;IAEvC,sBAAsB;IACtB,kEAAkE;;IAElE,uBAAuB;IACvB;MACE,mCAAmC;MACnC,aAAa;IACf;EACF;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,mHAAmH;EACnH,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,mHAAmH;EACnH,0BAA0B;EAC1B,oCAAoC;EACpC,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,mCAAmC;EACnC,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB;;wBAEsB;EACtB;;uBAEqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;EACb;;wBAEsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gDAAgD;EAChD,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,UAAU;EACV,kCAAkC;EAClC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,0CAA0C;EAC1C,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,eAAe;EACf,QAAQ;EACR,SAAS;EACT,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,8EAA8E;EAC9E,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,qDAAqD;EACrD,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,yDAAyD;EACzD,8EAA8E;EAC9E,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,gCAAgC;;EAEhC,sEAAsE;EACtE,gBAAgB;;EAEhB,oCAAoC;EACpC,wCAAwC;;EAExC;IACE,kDAAkD;IAClD,uDAAuD;EACzD;AACF;;;;;AAKA,yCAAyC;AACzC;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,8EAA8E;EAC9E,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,oJAAoJ;EACpJ,uFAAuF;AACzF;;AAsBA;EACE;IAEE,0DAA0D;IAE1D,uBAAuB;IAEvB,kBAAkB;IAClB,UAAU;EACZ;EACA;IAEE,2CAA2C;IAE3C,yBAAyB;IAEzB,eAAe;IACf,UAAU;EACZ;AACF;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ;;cAEY;EACZ,aAAa;EACb,8IAA8I;EAC9I,mFAAmF;AACrF;;AAsBA;EACE;IAEE,2CAA2C;IAE3C,yBAAyB;IAEzB,eAAe;IACf,UAAU;EACZ;EACA;IAEE,0DAA0D;IAE1D,uBAAuB;IAEvB,kBAAkB;IAClB,UAAU;EACZ;AACF;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE;MACI,mBAAmB;MACnB,UAAU;EACd;EACA;MACI,qBAAqB;MACrB,WAAW;EACf;AACF;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,uFAAuF;EACvF,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,UAAU;EACV,qCAAqC;EACrC,mBAAmB;EACnB,yCAAyC;EACzC,4BAA4B;EAC5B,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B,oCAAoC;AACpC,WAAW;AACX,yCAAyC;AACzC,4BAA4B;AAC5B,oCAAoC;AACpC,8BAA8B;AAC9B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,OAAO;EACP,eAAe;AACjB;AACA;EACE,8EAA8E;EAC9E,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX;sBACoB;EACpB,mBAAmB;EACnB,2DAA2D;EAC3D,aAAa;EACb,sBAAsB;EACtB,UAAU,EAAE,6BAA6B;EACzC,yBAAyB;EACzB,2EAA2E;EAC3E,sCAAsC;AACxC;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,+EAA+E;AACjF;AACA;EACE,gFAAgF;AAClF;AACA;EACE,kFAAkF;AACpF;AACA;EACE,mFAAmF;AACrF;AACA;EACE,gFAAgF;AAClF;AACA;EACE,iFAAiF;AACnF;AACA;EACE,mFAAmF;AACrF;AACA;EACE,oFAAoF;AACtF;AACA;EACE;IACE,2CAA2C;IAC3C,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,0CAA0C;IAC1C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;AACA;;GAEG;AACH;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,0CAA0C;IAC1C,UAAU;EACZ;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,qCAAqC;IACrC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,UAAU;EACZ;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB;;wBAEsB;EACtB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;EACX,sCAAsC,EAAE,4BAA4B;AACtE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;;AAGA;EACE,kBAAkB;EAClB;;2BAEyB;EACzB,6DAA6D;EAC7D,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB;;2BAEyB;EACzB,6DAA6D;EAC7D,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,0CAA0C;EAC1C,mHAAmH;EACnH,0BAA0B;EAC1B,oCAAoC;EACpC,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,uDAAuD;EACvD,WAAW;EACX,YAAY;;EAEZ,kCAAkC;AACpC;;AAEA,qDAAqD;AACrD;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB;;uCAEqC;AACvC;;AAEA;EACE,OAAO,SAAS;EAChB,KAAK,YAAY;AACnB;;AAEA;EACE,WAAW,0BAA0B;EACrC,MAAM,oBAAoB,EAAE;AAC9B;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EAEU,oFAAoF;AAC9F;;AAaA;EACE;IAEU,qBAAqB;EAC/B;EACA;IAEU,yBAAyB;EACnC;AACF;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;;AAGA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,kBAAkB,EAAE,+BAA+B;EACnD,eAAe;EACf,uDAAuD,EAAE,4CAA4C;EACrG,kCAAkC;EAClC,mBAAmB;EACnB;;;iCAG+B;EAC/B,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;;;8BAG4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB,EAAE,uCAAuC;AACjE;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,mBAAmB,EAAE,uDAAuD;EAC5E,wBAAwB;EACxB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB,EAAE,uDAAuD;EAC5E,kBAAkB,EAAE,wDAAwD;EAC5E,QAAQ;EACR,WAAW,EAAE,+BAA+B;EAC5C,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB,EAAE,iCAAiC;EACxD,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA;EACE,6BAA6B,EAAE,uCAAuC;AACxE;;AAEA;EACE,6BAA6B,EAAE,gDAAgD;AACjF;AACA;EACE,aAAa,EAAE,8CAA8C;AAC/D;AACA;EACE,UAAU,EAAE,sCAAsC;EAClD,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB,EAAE,8CAA8C;EAChE,WAAW,EAAE,qCAAqC;EAClD,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA,gCAAgC;AAChC;EACE,YAAY,EAAE,4BAA4B;AAC5C;AACA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB,EAAE,qBAAqB;EACzC,kBAAkB;EAClB,uBAAuB,EAAE,oCAAoC;EAC7D,WAAW,EAAE,eAAe;EAC5B,kBAAkB,EAAE,4BAA4B;EAChD,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU,EAAE,4CAA4C;EACxD,UAAU,EAAE,wBAAwB;EACpC,oCAAoC,EAAE,mBAAmB;EACzD,eAAe,EAAE,sBAAsB;EACvC,mBAAmB,EAAE,oCAAoC;EACzD,gBAAgB,EAAE,wCAAwC;EAC1D,WAAW,EAAE,oDAAoD;AACnE;AACA;EACE,SAAS;EACT,OAAO;EACP,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,QAAQ;EACR,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,QAAQ;EACR,6CAA6C;AAC/C;AACA;EACE,QAAQ;EACR,UAAU;EACV,2BAA2B;AAC7B;;AAEA,+DAA+D;AAC/D;EACE,mBAAmB;EACnB,UAAU,EAAE,6BAA6B;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,OAAO;EACP,SAAS;EACT,6CAA6C;EAC7C,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,QAAQ;EACR,UAAU;EACV,2CAA2C;EAC3C,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,QAAQ;EACR,QAAQ;EACR,6CAA6C;EAC7C,6BAA6B;EAC7B,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;AAClC;;;;;AAKA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,oBAAoB,EAAE,0CAA0C;EAChE,YAAY,EAAE,8CAA8C;EAC5D,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;AACA;;;;;;;;EAQE,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B,EAAE,iCAAiC;AACjE;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B,EAAE,iCAAiC;AAChE;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB,EAAE,iBAAiB;EAC5C,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,qBAAqB,MAAM,8BAA8B;EACzD,mBAAmB,QAAQ,sBAAsB;EACjD,uBAAuB,IAAI,oBAAoB;AACjD;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,8BAA8B,EAAE,iCAAiC;EACjE,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;AACA;eACe,gBAAgB;AAC/B;AACA;EACE,yBAAyB,IAAI,qBAAqB;EAClD,kBAAkB,WAAW,kBAAkB;EAC/C,sBAAsB,OAAO,gBAAgB;EAC7C,0CAA0C,EAAE,eAAe;EAC3D,WAAW,kBAAkB,gBAAgB;AAC/C;AACA,0BAA0B;AAC1B;EACE,gFAAgF;AAClF;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,2BAA2B,EAAE;AACtC;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qDAAqD;AACvD;AACA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;AACA,qCAAqC;AACrC;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB,EAAE,kBAAkB;IACvC,YAAY,WAAW,kBAAkB;EAC3C;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,yBAAyB,EAAE,sBAAsB;EACjD,sBAAsB;EACtB,wBAAwB,EAAE,uBAAuB;EACjD,+BAA+B,EAAE,mBAAmB;AACtD;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA,SAAS;AACT;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;;;;;;;;EAQE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B,EAAE,iCAAiC;AACjE;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B,EAAE,iCAAiC;AAChE;AACA;;;;;;;;GAQG;;AAEH;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,2BAA2B;EAC3B,8BAA8B,EAAE,iCAAiC;EACjE,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B;;4BAE0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;;4BAE0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;;AAGA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;AACA;;;;;;;;EAQE,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B,EAAE,iCAAiC;AACjE;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B,EAAE,iCAAiC;AAChE;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB,EAAE,iBAAiB;EAC5C,kBAAkB,EAAE,8BAA8B;AACpD;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,qBAAqB,MAAM,8BAA8B;EACzD,mBAAmB,QAAQ,sBAAsB;EACjD,uBAAuB,IAAI,oBAAoB;AACjD;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,8BAA8B,EAAE,iCAAiC;EACjE,kBAAkB;AACpB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,0CAA0C;AAC5C;AACA;;EAEE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS,EAAE,6BAA6B;EACxC,QAAQ;EACR,yBAAyB;EACzB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iEAAiE;EACjE,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,KAAK,QAAQ,EAAE,UAAU,EAAE,SAAS,EAAE;EACtC,OAAO,WAAW,EAAE,UAAU,EAAE,SAAS,EAAE;AAC7C;;AAEA;EACE,KAAK,QAAQ,EAAE,UAAU,EAAE,SAAS,EAAE;EACtC,OAAO,WAAW,EAAE,UAAU,EAAE,SAAS,EAAE;AAC7C;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc,QAAQ,oBAAoB;EAC1C,WAAW,WAAW,mCAAmC;AAC3D;;;AAGA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA,cAAc;AACd;EACE,KAAK,qBAAqB,EAAE,YAAY,EAAE;EAC1C,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,WAAW,EAAE;AACtB;;AAEA;EACE,KAAK,QAAQ,EAAE;EACf,OAAO,WAAW,EAAE;AACtB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,IAAI,uBAAuB;EAC9C,gBAAgB;AAClB;AACA;EACE,uBAAuB,IAAI,sBAAsB;EACjD,mBAAmB,QAAQ,oBAAoB;EAC/C,aAAa,cAAc,aAAa;EACxC,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B","sourcesContent":[".app-bg-container {\n  background-color: #022636;\n  padding: 15px;\n  padding-left: 0px;\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  /* animation: scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both; */\n}\n\nbody{\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  /* background-color:  #2E7D92 !important; */\n  /* background: radial-gradient(circle, \n  #A6D3DE 0%, \n  #4F94A8 30%,\n  #1A6E84 60%, \n  #094762 100% \n); */\nfont-family: \"Inter\", serif!important;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n\n}\n\n.transition-bg-container {\n  /* background-image: linear-gradient(to right, #083d53, #729caf, #4f7871); */\n  padding: 15px;\n  padding-left: 0px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  height: 100vh;\n  /* animation: scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both; */\n}\n.sidebar-bg-container {\n  width: 20%;\n  /* background-color: blue; */\n  padding: 15px;\n}\n\n.input-box {\n  position: relative; /* Make the container relative */\n  width: 100%;\n}\n\n.input-box input {\n  width: 100%;\n  padding-right: 35px; /* Add padding to the right to make space for the icon */\n}\n\n.input-box .icon {\n  position: absolute;\n  right: 10px;\n  top: 65%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-size: 25px;\n  color: #000;\n}\n\n.app-content-container {\n  width: 80%;\n  height: 100%;\n  border-radius: 44px;\n  background: #d1e7f1;\n  box-shadow: 0px 4px 11.4px 0px rgba(0, 0, 0, 0.17);\n}\n\n.app-main-bg-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.app-main-bg-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.app-main-bg-container::-webkit-scrollbar-thumb {\n  background: blue;\n  /* Customize the scrollbar thumb color */\n}\n\n.app-main-bg-container::-webkit-scrollbar-thumb:hover {\n  background: violet;\n  /* Customize the scrollbar thumb color on hover */\n}\n\n.new-sidebar {\n  /* background-color: #f9f9f9; */\n  width: 100%;\n  height: 100%;\n  padding: 0px;\n}\n\n.new-sidebar-content-container {\n  height: 90%;\n  /* background-color: skyblue; */\n}\n\n.user-logout-container {\n  height: 10%;\n  position: relative;\n  /* background-color: bisque; */\n}\n\n.user-logo-container {\n  width: 44.955px;\n  height: 44.955px;\n  flex-shrink: 0;\n  background-image: linear-gradient(180deg, #2C7B74 0%, #0664AE 100%);\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  right: 75%;\n}\n\n.user-logo-text {\n  color: #FFF;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.logout-container {\n  border-radius: 12px;\n  /* opacity: 0.4; */\n  background-image: url(\"../../assets/images/Rectangle 10.png\");\n  background-repeat: no-repeat;\n  width: 80%;\n  height: 44.955px;\n  padding: 10px;\n  background-size: cover;\n  cursor: pointer;\n}\n\n.logout-text {\n  margin: 0px;\n  color: #FFF;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.logout-text-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 80%;\n}\n\n.logout-icon {\n  color: #FFF;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.enmovil-logo-container {\n  width: 100%;\n  height: 13%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.chat-name-container {\n  width: 100%;\n  border-radius: 27.438px;\n  border: 0px solid rgba(98, 211, 167, 0.00);\n  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.00) 100%);\n  backdrop-filter: blur(64.0224838256836px);\n  padding: 10px;\n}\n\n.selct-chat-name-container {\n  width: 100%;\n  padding: 15px;\n  padding-bottom: 0px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n/* .chat-name-container:hover {\n  border-radius: 27.438px;\n  border: 0px solid rgba(98, 211, 167, 0.00);\n  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.00) 100%);\n  backdrop-filter: blur(64.0224838256836px);\n  padding: 10px;\n} */\n\n.copy-link-popup-container {\n  width: 450px;\n  height: 195px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #FFF;\n  font-size: 30px;\n  font-weight: bold;\n  font-weight: 600;\n  border-radius: 57.515px;\n  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));\n  padding: 20px;\n}\n\n.copy-txt {\n  color: #FFF;\n  font-size: 25px;\n  font-weight: bold;\n  font-weight: 600;\n}\n\n.chat-name-bg-container {\n  border-radius: 27.438px;\n  border: 0px solid rgba(98, 211, 167, 0.00);\n  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.00) 100%);\n  backdrop-filter: blur(64.0224838256836px);\n  /* background-image: url(\"../../assets/images/Rectangle\\ 5.png\"); */\n  padding: 10px;\n  width: 100%;\n  /* padding-left: 20px;\n  padding-right: 20px; */\n}\n.pinpopup-chat-name-bg-container{\n  height: 210px;\n  overflow-y: auto;\n  border-radius: 27.438px;\n  border: 0px solid rgba(98, 211, 167, 0.00);\n  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.00) 100%);\n  backdrop-filter: blur(64.0224838256836px);\n  /* background-image: url(\"../../assets/images/Rectangle\\ 5.png\"); */\n  padding: 10px;\n  width: 100%;\n}\n.pinpopup-chat-name-bg-container::-webkit-scrollbar {\n  width: 5px !important;\n  height: 0;\n  border-radius: 5px;\n}\n\n.pinpopup-chat-name-bg-container::-webkit-scrollbar-thumb {\n  background: rgb(215, 215, 217) !important;\n  height: 10px !important;\n}\n\n.pinpopup-chat-name-bg-container::-webkit-scrollbar-thumb:hover {\n  background: rgb(139, 97, 97);\n}\n\n.pinpopup-chat-name-bg-container::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 5px;\n  height: 5px !important;\n}\n.chat-history-name {\n  margin: 0px;\n  color: #FFF;\n  font-size: 18.354px;\n  font-weight: 600;\n}\n\n.new-chat-text-container {\n  background-image: url(\"../../assets/images/chat_bg_container.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-radius: 20px;\n}\n\n.new-text {\n  margin: 0px;\n  color: #FFF;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.new-message-icon {\n  color: #fff;\n  font-size: 17px;\n  margin-right: 5px;\n}\n\n.previous-history-name {\n  margin: 0px;\n  color: #ffffff;\n  font-size: 17px;\n  font-weight: 600;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  padding-left: 15px;\n  z-index: 1000;\n}\n\n.chat-name-text {\n  color: #fff;\n  font-size: 15px;\n  margin: 0px;\n  margin-left: 10px;\n}\n\n.content-bg-container {\n  width: 80%;\n  height: 100%;\n  background-color: #e7e5e5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.chat-container {\n  width: 80%;\n  height: 100%;\n}\n\n.content-header-container {\n  background-color: transparent;\n  width: 90%;\n  z-index: 1000;\n  padding: 20px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-bottom: 1px solid #8bb5dc;\n}\n\n.dashboard-header-container {\n  background-color: transparent;\n  width: 95%;\n  height: 10%;\n  z-index: 1000;\n  padding: 30px;\n  padding-top: 40px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border-bottom: 1px solid #8bb5dc;\n  position: sticky;\n}\n\n.share-popup-container {\n  width: 450px;\n  height: 195px;\n  border-radius: 23px;\n  background: #FFF;\n  position: relative;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.share-chat-with-link {\n  font-size: 25px;\n  font-weight: bold;\n  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.generate-link {\n  width: 151.657px;\n  height: 39.91px;\n  flex-shrink: 0;\n  color: #fff;\n  border-radius: 9.484px;\n  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));\n  border: 0px;\n}\n\n/* .app-container{\n    background-color: #f5f5f5;\n    display: flex;\n    height: 92vh;\n}\n.navbar {\n    background-color: #f9f9f9;\n    width: 100%;\n    height: 8vh;\n    border-bottom: 1px solid #EAEAEA;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .navbar-logo-container{\n    width: 15%;\n    height: 100%;\n    padding-left: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .navbar-logo{\n    width: 80%;\n    height: 70%;\n  } */\n.content {\n  /* background-color: # ; */\n  width: 80%;\n  padding: 20px;\n  /* border: #000 0.5px solid; */\n}\n\n.new-chat-text {\n  color: #000;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0px;\n}\n\n.edit-icon {\n  width: 25px;\n  height: 25px;\n  flex-shrink: 0;\n  margin-left: 20px;\n  cursor: pointer;\n  color: #0664AE;\n}\n\n.new-edit-icon {\n  font-size: 1vw;\n  flex-shrink: 0;\n  margin-right: 5px;\n  color: #0664AE;\n}\n\n.sidebar-content-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.sidebar-content-container::-webkit-scrollbar-thumb {\n  background: blue;\n  /* Customize the scrollbar thumb color */\n}\n\n.sidebar-content-container::-webkit-scrollbar-thumb:hover {\n  background: violet;\n  /* Customize the scrollbar thumb color on hover */\n}\n\n.alternate_chat_input {\n  padding: 7px;\n  padding-left: 10px;\n  border: 1px solid #2C7B74;\n  border-radius: 10px;\n  box-shadow: 0px 4px 11.4px 0px rgba(0, 0, 0, 0.17);\n  width: 60%;\n  color: #000;\n  font-size: 17px;\n  outline: none;\n}\n\n.new-chat-bg-container {\n  height: 15%;\n  border-top: 3px solid #e1dede;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.new-chat-container {\n  border: 1px solid #8F8686;\n  border-radius: 10px;\n  height: 57%;\n  width: 100%;\n  display: flex;\n}\n\n.plus-icon-container {\n  width: 20%;\n  height: 100%;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.new-chat-txt-container {\n  display: flex;\n  align-items: center;\n  width: 80%;\n}\n\n.chat-result-text {\n  /* color: #504E4E; */\n  color: #000;\n  font-size: 17px;\n  font-weight: 500;\n}\n\n.chat-user-logo-container {\n  background: linear-gradient(180deg, #2C7B74 0%, #0664AE 100%);\n  width: 44.955px;\n  height: 44.955px;\n  flex-shrink: 0;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ai-result-text-container {\n  padding-left: 20px;\n  padding-right: 20px;\n  max-height: 570px;\n  width: 100%;\n  position: relative;\n  overflow-y: auto;\n}\n\n.f17 {\n  font-size: 17px;\n}\n\n.f23 {\n  font-size: 23px;\n}\n\n.f13 {\n  font-size: 13px;\n}\n\n.f15 {\n  font-size: 15px;\n}\n\n.f19 {\n  font-size: 19px;\n}\n\n.mt5p {\n  margin-top: 5px;\n}\n\n.ml5p {\n  margin-left: 5px;\n}\n\n.mr5p {\n  margin-right: 5px;\n}\n\n.pl10p {\n  padding-left: 10px;\n}\n\n.mt10p {\n  margin-top: 10px;\n}\n\n.mr10p {\n  margin-right: 10px;\n}\n\n.m0p {\n  margin: 0px;\n}\n\n.f-bold {\n  font-weight: bold;\n}\n\n.f-500 {\n  font-weight: 500;\n}\n\n.f-600 {\n  font-weight: 600;\n}\n\n.f-700 {\n  font-weight: 700;\n}\n\n.pl10 {\n  padding-left: 40px\n}\n\n.pr10 {\n  padding-right: 40px\n}\n\n.black {\n  color: black;\n}\n\n.sidebar-icon {\n  position: absolute;\n  left: 90%;\n  cursor: pointer;\n}\n\n.content-sidebar-icon {\n  position: absolute;\n  right: 97%;\n  top: 13%;\n  cursor: pointer;\n}\n\n.popup {\n  /* Popup styles */\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 5px 10px;\n  border-radius: 5px;\n  font-size: 14px;\n  top: 10px;\n  left: 40px;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n.new-popup {\n  /* Popup styles */\n  position: absolute;\n  background-color: #f9f9f9;\n  color: blue;\n  padding: 5px 10px;\n  border-radius: 5px;\n  font-size: 14px;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  width: 400px;\n  height: 150px;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.full-content-bg-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.content-container {\n  width: 100%;\n  height: 78%;\n  overflow-y: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 50px;\n}\n\n.content-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.content-container::-webkit-scrollbar-thumb {\n  background: blue;\n  /* Customize the scrollbar thumb color */\n}\n\n.content-container::-webkit-scrollbar-thumb:hover {\n  background: violet;\n  /* Customize the scrollbar thumb color on hover */\n}\n\n.full-content-container {\n  width: 100%;\n  height: 85%;\n  overflow-y: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  padding-top: 50px;\n}\n\n.full-content-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.full-content-container::-webkit-scrollbar-thumb {\n  background: blue;\n  /* Customize the scrollbar thumb color */\n}\n\n.full-content-container::-webkit-scrollbar-thumb:hover {\n  background: violet;\n  /* Customize the scrollbar thumb color on hover */\n}\n\n.tooltip {\n  visibility: hidden;\n  position: absolute;\n  right: 50%;\n  /* Position the tooltip on the right side of the icon */\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: #333;\n  color: #fff;\n  padding: 5px;\n  border-radius: 4px;\n  white-space: nowrap;\n}\n\n.chat-history-container:hover .tooltip {\n  visibility: visible;\n  /* Show the tooltip on hover */\n}\n\n.search-box-bg-container {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  padding-bottom: 10px;\n}\n\n.search-box-container {\n  display: flex;\n  flex-direction: column;\n  width: 80%;\n  background-color: #fff;\n  border-radius: 15px;\n  box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);\n  padding-left: 20px;\n  padding-right: 20px;\n  position: relative;\n  border: 1px solid #022636;\n}\n\n.rocket-icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 5%;\n  max-height: 50px;\n  height: 50px;\n  cursor: pointer;\n}\n\n.search-input {\n  background-color: transparent;\n  padding: 15px;\n  width: 100%;\n  border: none;\n  font-size: 17px;\n  color: black;\n  font-weight: 500;\n  padding-left: 0px;\n  outline: none;\n  /* Hide vertical scrollbar */\n}\n\ninput[type=\"text\"] {\n  word-wrap: break-word;\n  /* Allow text to wrap to the next line */\n  white-space: normal;\n  /* Allow text to wrap to the next line */\n  overflow-wrap: break-word\n}\n\n.rocket-container {\n  width: 100%;\n  height: 80%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px;\n  padding: 5px;\n  padding-left: 7px;\n  padding-right: 7px;\n  margin-bottom: 5px;\n}\n\n.rocket-icon-bg-container {\n  background-image: linear-gradient(to right, #022636, #175068);\n}\n\n.previous-chat-container {\n  width: 80%;\n  height: 100%;\n  padding-top: 50px;\n}\n\n.dashboard-chat-container {\n  width: 80vw;\n  height: 98%;\n  padding: 50px;\n  overflow-y: scroll;\n  position: relative;\n}\n\n.chat-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.chat-container::-webkit-scrollbar-thumb {\n  background: blue;\n  /* Customize the scrollbar thumb color */\n}\n\n.chat-container::-webkit-scrollbar-thumb:hover {\n  background: violet;\n  /* Customize the scrollbar thumb color on hover */\n}\n\n.previous-chat-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.previous-chat-container::-webkit-scrollbar-thumb {\n  background: blue;\n  /* Customize the scrollbar thumb color */\n}\n\n.previous-chat-container::-webkit-scrollbar-thumb:hover {\n  background: violet;\n  /* Customize the scrollbar thumb color on hover */\n}\n\n.chat-result-bg-container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  position: relative;\n}\n\n.ai-result-bg-container {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  position: relative;\n}\n\n.chat-result-container {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  background: rgba(6, 100, 174, 0.13);\n  padding: 20px;\n}\n\n.ai-result-container {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  background: #E4FFF5;\n  padding: 20px;\n  position: relative;\n  padding-top: 30px;\n}\n\n.ai-logo-container {\n  background: linear-gradient(180deg, #2C7B74 0%, #0664AE 100%);\n  width: 44.955px;\n  height: 44.955px;\n  flex-shrink: 0;\n  border-radius: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.robot-logo {\n  width: 50%;\n}\n\n.chat-result-text-container {\n  width: 100%;\n  margin-left: 10px;\n  padding-right: 30px;\n  overflow: auto;\n  position: relative;\n  max-height: 570px;\n}\n\n.chat-name-bg-container::-webkit-scrollbar {\n  width: 5px !important;\n  height: 0;\n  border-radius: 5px;\n}\n\n.chat-name-bg-container::-webkit-scrollbar-thumb {\n  background: rgb(215, 215, 217) !important;\n  height: 10px !important;\n}\n\n.chat-name-bg-container::-webkit-scrollbar-thumb:hover {\n  background: rgb(139, 97, 97);\n}\n\n.chat-name-bg-container::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 5px;\n  height: 5px !important;\n}\n\n.type-loader {\n  font-size: 24px;\n  /* Adjust the font size as needed */\n}\n\n.dot {\n  opacity: 0;\n  animation: dotAnimation 1s infinite!important;\n  animation-delay: 0.2s;\n  display: inline-block;\n  font-weight: bold;\n}\n\n@keyframes dotAnimation {\n  0% {\n    opacity: 0;\n  }\n\n  25% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.bordered-table {\n  border-collapse: collapse;\n  border: 2px solid #FFC7C7;\n  /* Adjust the border style and color as needed */\n  background-color: #f9f9f9;\n}\n\n.bordered-table th,\n.bordered-table td {\n  border: 1px solid #c39f9f;\n  /* Adjust the border style and color as needed */\n  padding: 8px;\n  /* Adjust the cell padding as needed */\n  text-align: left;\n  /* Adjust the cell text alignment as needed */\n}\n\n.container {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  max-width: 1200px;\n  width: 100%;\n  height: 90vh;\n}\n.chat-result-text-container::-webkit-scrollbar {\n  width: 10px !important;\n  height: 0;\n  border-radius: 5px;\n}\n\n.chat-result-text-container::-webkit-scrollbar-thumb {\n  background: rgb(215, 215, 217) !important;\n  height: 10px !important;\n}\n\n.chat-result-text-container::-webkit-scrollbar-thumb:hover {\n  background: rgb(139, 97, 97);\n}\n.btun {\n  align-items: center;\n  background-color: #4d61fc;\n  /* Replace with your color value */\n  border-radius: 3px;\n  border: 0;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  font-size: 16px;\n  padding: 15px;\n  transition: 0.2s;\n  font-weight: bold;\n}\n\n.btun:hover {\n  background-color: #2036de;\n  /* Hover background color */\n  transform: translateY(-2px);\n}\n\nform,\nfieldset {\n  border: 0;\n  padding: 0;\n  margin: 0;\n}\n\nstrong {\n  color: #2f2f2f;\n  display: block;\n  font-size: 40px;\n}\n\nspan {\n  color: #2f2f2f;\n}\n\n.login {\n  border-radius: 5px;\n  box-shadow: 0 7px 30px -10px rgba(150, 170, 180, 0.5);\n  ;\n  height: auto;\n  max-width: 400px;\n  padding: 40px 15px;\n  text-align: center;\n  width: 100%;\n\n  .fas {\n    color: #4d61fc;\n    font-size: 35px;\n    margin-bottom: 5px;\n  }\n\n  .user-fas {\n    margin-top: 15px;\n    font-size: 23px !important;\n    cursor: pointer;\n  }\n\n  strong {\n    color: #2f2f2f;\n    display: block;\n    font-size: 40px;\n  }\n\n  span {\n    color: #2f2f2f;\n  }\n\n  .create-account {\n    border-top: 1px solid #e2e2e2;\n    display: flex;\n    justify-content: center;\n    margin-top: 30px;\n    padding-top: 30px;\n\n    strong {\n      font-size: 16px;\n      margin-left: 5px;\n      text-decoration: underline;\n    }\n  }\n}\n\n.login {\n  background: #fff;\n  /* Replace with your background color */\n\n  .form {\n    margin-top: 30px;\n    padding: 0 20px;\n\n    .form-row {\n      position: relative;\n      text-align: left;\n\n      .fas {\n        font-size: 15px;\n        position: absolute;\n        right: 10px;\n        top: 30px;\n      }\n\n      &.bottom {\n        display: flex;\n        justify-content: space-between;\n\n        .forgot {\n          color: #4d61fc;\n          /* Replace with your color value */\n        }\n      }\n\n      &.button-login {\n        margin-top: 50px;\n\n        .fas {\n          position: static;\n        }\n      }\n\n      /* Style checkbox remenber */\n      .form-check {\n        input[type=checkbox]+label {\n          color: #555;\n          cursor: pointer;\n          display: block;\n        }\n\n        input[type=checkbox] {\n          display: none;\n        }\n\n        /* Style label input checkbox */\n        input[type=checkbox]+label:before {\n          border-radius: 3px;\n          border: 1px solid #e2e2e2;\n          color: transparent;\n          content: \"\\2714\";\n          display: inline-block;\n          height: 15px;\n          margin-right: 5px;\n          transition: 0.2s;\n          vertical-align: bottom;\n          width: 15px;\n          line-height: 16px;\n          font-size: 12px;\n          text-align: center;\n        }\n\n        /* Input active scale */\n        input[type=checkbox]+label:active:before {\n          transform: scale(1.1);\n        }\n\n        /* Color input checked */\n        input[type=checkbox]:checked+label:before {\n          background-color: #4d61fc;\n          /* Replace with your color value */\n          border-color: #4d61fc;\n          /* Replace with your color value */\n          color: #fff;\n          /* Replace with your color value */\n        }\n      }\n    }\n\n    .form-label {\n      color: #555;\n      font-size: 12px;\n    }\n  }\n\n  .form-password,\n  .form-text {\n    border-radius: 2px;\n    border: 0;\n    height: 40px;\n    margin-bottom: 20px;\n    padding: 0 40px 0 10px;\n    width: 100%;\n    background: #f1f1f1 no-repeat;\n    transition: 100ms all linear 0s;\n\n    /* Style and effect focus inputs */\n    background-image: linear-gradient(109.6deg, rgba(116, 18, 203, 1) 11.2%, rgba(230, 46, 131, 1) 91.2%);\n    background-size: 0 2px, 100% 1px;\n    background-position: 50% 100%, 50% 100%;\n\n    /* Effect transition */\n    transition: background-size 0.3s cubic-bezier(0.64, 0.09, 0.08, 1);\n\n    /* Focus active input */\n    &:focus {\n      background-size: 100% 2px, 100% 1px;\n      outline: none;\n    }\n  }\n}\n\n.arrow {\n  font-size: 20px;\n  margin-left: 10px;\n}\n\n.select-chat-name-bg {\n  border-radius: 12.689px;\n  border: 0px solid rgba(98, 211, 167, 0.00);\n  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.00) 100%);\n  backdrop-filter: blur(10px);\n  width: 100%;\n  padding: 7px;\n  padding-left: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  position: 'relative';\n  margin-bottom: 5px;\n}\n\n.chat-name-bg {\n  /* background-color: #9a8c98; */\n  width: 100%;\n  padding: 7px;\n  padding-left: 12px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  position: 'relative';\n  margin-bottom: 5px;\n}\n\n.bg {\n  padding: 10px;\n}\n\n.comment {\n  font-size: 20px;\n  color: #FFF;\n}\n\n.chat-name-bg:hover {\n  border: 0px solid rgba(98, 211, 167, 0.00);\n  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.00) 100%);\n  backdrop-filter: blur(8px);\n  /* Adjust the blur value as needed */\n  width: 100%;\n  border-radius: 12.689px;\n}\n\n.delete {\n  font-size: 17px;\n}\n\n.select-chat-name-text-container {\n  width: 80%;\n  display: flex;\n  height: 30px;\n  overflow: hidden;\n}\n\n.chat-name-text-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  height: 30px;\n  overflow: hidden;\n}\n\n.chat-text {\n  width: 89%;\n}\n\n.edit-delete-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40%;\n  height: 100%;\n}\n\n.image-container {\n  width: 100%;\n}\n\n.full-image-container {\n  width: 100%;\n}\n\n.image {\n  width: 90%;\n  height: 520px;\n}\n\ntextarea {\n  resize: none !important;\n}\n\ntextarea::-webkit-scrollbar {\n  width: 5px;\n  height: 0;\n}\n\ntextarea::-webkit-scrollbar-thumb {\n  background: #9E9FA5;\n  height: 5px !important;\n}\n\ntextarea::-webkit-scrollbar-thumb:hover {\n  background: rgb(139, 97, 97);\n}\n\ntextarea::-webkit-scrollbar-track {\n  background: transparent;\n  border-radius: 5px;\n  height: 5px !important;\n}\n\n.error-msg {\n  font-size: 17px;\n  font-weight: 500;\n  color: red;\n  float: left;\n}\n\n.delete-popup {\n  position: fixed;\n  top: 0;\n  left: 0%;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000000001;\n  /* Ensure it's on top */\n}\n\n.delete-content {\n  background-color: white;\n  width: 450px;\n  padding: 30px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  text-align: center;\n  /* Center the content */\n}\n\n.close-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n\n.popup-buttons {\n  display: flex;\n  justify-content: center;\n  margin-top: 30px;\n}\n\n.table-bordered {\n  border-collapse: collapse;\n  width: 100%;\n}\n\n.table-bordered th,\n.table-bordered td {\n  border: 1px solid #ddd;\n  padding: 12px;\n  text-align: center;\n}\n\n.table-bordered th {\n  background-color: #c3c1bf;\n  /* Header background color */\n  color: #fff;\n  /* Header text color */\n}\n\n.table-bordered tr:nth-child(even) {\n  background-color: #f2f2f2;\n  /* Even row background color */\n}\n\n.table-bordered tr:nth-child(odd) {\n  background-color: #e0e0e0;\n  /* Odd row background color */\n}\n\n.share-icon {\n  color: #0664AE;\n  font-size: 20px;\n}\n\n.share-icon-container {\n  /* width: 93.271px; */\n  /* height: 37px; */\n  flex-shrink: 0;\n  border-radius: 12.333px;\n  border: 1.5px solid #0664AE;\n  cursor: pointer;\n  font-size: 0.9vw;\n  padding: 5px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.save-icon-container{\n  /* height: 37px; */\n  flex-shrink: 0;\n  border-radius: 12.333px;\n  border: 1.5px solid #0664AE;\n  cursor: pointer;\n  color: #0664AE;\n  padding: 5px;\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.cancel-icon-container{\n  height: 37px;\n  flex-shrink: 0;\n  border-radius: 12.333px;\n  border: 0.771px solid red;\n  cursor: pointer;\n  padding-left: 10px;\n  padding-right: 10px;\n  color: red;\n}\n.share-icon-container:hover {\n  border: 3px solid #0664AE;\n}\n.save-icon-container:hover{\n  border: 3px solid #0664AE;\n}\n.cancel-icon-container:hover{\n  border: 3px solid red;\n}\n.share-text {\n  color: #0664AE;\n  font-size: 1vw;\n  font-weight: 500;\n  margin: 0px;\n  margin-left: 3px;\n}\n\n.overlay {\n  position: fixed;\n  top: 0%;\n  bottom: 4%;\n  left: 0%;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  /* Semi-transparent black background */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  /* z-index: 1234567890987; */\n  /* Set a high z-index value */\n  z-index: 100000005;\n  /* border-radius: 50px; */\n}\n\n.share-popup {\n  background: #fff;\n  /* White background */\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  /* Box shadow for a subtle effect */\n  text-align: center;\n  z-index: 10001;\n  width: 500px;\n}\n\n.share-content-bg-container {\n  width: 100vw;\n  height: 100vh;\n  background-color: #fff;\n  border-radius: 0px;\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n  /* overflow-y: auto;\n  padding: 20px;\n  position: relative; */\n}\n.share-bg-container{\n  width: 100vw;\n  height: 100vh;\n  /* display: flex;\n  justify-content: center;\n  align-items: center; */\n}\n.share-chat-container {\n  width: 100%;\n  /* height: 90vh; */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.share-content-bg-container::-webkit-scrollbar {\n  width: 10px !important;\n  height: 0;\n  border-radius: 5px;\n}\n\n.share-content-bg-container::-webkit-scrollbar-thumb {\n  background: rgb(215, 215, 217) !important;\n  height: 10px !important;\n}\n\n.share-content-bg-container::-webkit-scrollbar-thumb:hover {\n  background: rgb(139, 97, 97);\n}\n\n.share-content {\n  width: 70%;\n  /* height: 90%; */\n}\n\n.sidebar-popup {\n  position: absolute;\n  top: 10%;\n  left: 90%;\n  /* Position to the right of the name-container */\n  transform: translateX(10px);\n  background-color: #bcbec5;\n  border: 1px solid #ddd;\n  padding: 10px;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  z-index: 1;\n  /* Ensure it's above the content */\n  display: flex;\n  align-items: center;\n}\n\n.arrow-down {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%) rotate(-90deg);\n  left: -15px;\n  border-width: 0 10px 10px 10px;\n  border-style: solid;\n  border-color: transparent transparent #9E9FA5 transparent;\n}\n\n.popup-content {\n  white-space: nowrap;\n  /* Prevent content from wrapping */\n}\n\n.pin-icon-container {\n  border: 1px solid black;\n  border-radius: 5px;\n  padding: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n\n.pin-icon-container-active {\n  /* border: 1px solid rgb(7, 94, 131); */\n  border-radius: 5px;\n  padding: 7px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  /* background-color: #f9f9f9; */\n  /* margin-bottom: 5px; */\n}\n\n.pin-icon {\n  color: #fff;\n  font-size: 15px;\n  cursor: pointer;\n}\n\n.pin-icon-active {\n  color: #fff;\n  font-size: 15px;\n  /* cursor: pointer; */\n}\n\n.pin-popup-container {\n  width: 100%;\n  max-width: 350px;\n  background-color: #022636;\n  padding: 30px;\n  border-radius: 10px;\n  width: 25%;\n  z-index: 100001;\n  position: fixed;\n  top: 30%;\n  left: 40%;\n  transition: opacity 0.3s ease, visibility 0.3s ease; \n}\n\n.dashboard-input {\n  padding: 7px;\n  padding-left: 10px;\n  font-size: 14px;\n  border: 1px solid #9E9FA5;\n  border-radius: 5px;\n  width: 72%;\n}\n\n.dashboard-button {\n  padding: 7px;\n  margin-left: 5px;\n  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));\n  border-radius: 5px;\n  border-style: none;\n  color: #f9f9f9;\n  width: 28%;\n}\n\n.horizontal-line {\n  color: rgb(182, 182, 185);\n}\n\n.empty-dashboard-container {\n  width: 100%;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.dashboard-name-container {\n  background-color: #EBE4D1;\n  border-radius: 10px;\n  padding-left: 20px;\n  padding-right: 10px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n\n.dashboard-name {\n  margin: 0px;\n}\n\n.down-arrow {\n  margin-top: 0px;\n}\n.dashboard-card-container{\n  border-radius: 15px;\n  box-shadow: 0px 3.09px 3.09px 0px rgba(0, 0, 0, 0.25);\n  /* overflow: auto; */\n  display: flex;\n  flex-direction: column;\n}\n.dashboard-query-container {\n  /* border-top: 86.514px solid var(--Gradient, #2C7B74); */\n  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 20px;\n}\n\n.dashboard-query-text-container {\n  flex-grow: 1;\n  margin-right: 10px;\n}\n.summary-text{\n  color: #fff;\n}\n.dashboard-result-container {\n  background-color: #FCFCFC;\n  height: 100%;\n}\n\n.dashboard-response-text-container {\n  width: 100%;\n  position: \"relative\"\n}\n\n.loader {\n  border: 8px solid #f3f3f3;\n  /* Light grey */\n  border-top: 8px solid #3498db;\n  /* Blue color */\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.responsive-grid-layout {\n  /* margin: 16px; */\n  position: relative;\n}\n\n.layout {\n  overflow: hidden;\n  min-height: 95vh;\n}\n\n.react-grid-item {\n  /* background-color: #E4F1FF; */\n  border-radius: 10px;\n  color: black;\n  text-align: center;\n  box-shadow: rgba(0, 0, 0, 0.06) 0px 2px 4px;\n  transition: all 0.3s ease-in-out;\n\n  /* Initially hide the overflow to avoid content showing before hover */\n  overflow: hidden;\n\n  /* Add shadow for a lifting effect */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n  &:hover {\n    /* Change lifting effect color to peacock violet */\n    /* box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px; */\n  }\n}\n\n\n\n\n/* Add media queries for responsiveness */\n@media (max-width: 1200px) {\n  .react-grid-item {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 768px) {\n  .react-grid-item {\n    font-size: 12px;\n  }\n}\n\n.dashboard-bg-container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.dashboard-content-container {\n  height: 90%;\n  width: 100%;\n  overflow-y: auto;\n  padding: 30px;\n  position: relative;\n  margin-bottom: 30px;\n}\n\n.dashboard-summary {\n  color: black;\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.dashboard-result {\n  color: rgb(144, 100, 144);\n  font-size: 20px;\n  font-weight: bold;\n}\n\n.column-header-style {\n  font-weight: bold;\n  color: black;\n}\n\n#myGrid1 .ag-header.ag-pivot-off {\n  /* background: #176B87; */\n  color: #fff;\n  font-weight: bolder;\n  font-size: 0.95vw;\n}\n.chart-filter-container{\n  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));\n  padding: 20px;\n  border-radius: 20px;\n}\n.schedule-icon{\n  color: #0664AE;\n  font-size: 30px;\n  margin-right: 20px;\n  cursor: pointer;\n}\n.cron-schedule-container{\n  background-color: #fff;\n  border-radius: 10px;\n  /* padding: 30px; */\n  width: 70%;\n  max-width: 790px;\n  z-index: 100001;\n  /* box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset; */\n  /* animation: slide-in-blurred-tr 0.6s cubic-bezier(0.230, 1.000, 0.320, 1.000) both; */\n}\n@-webkit-keyframes slide-in-blurred-tr {\n  0% {\n    -webkit-transform: translate(1000px, -1000px) skew(-80deg, -10deg);\n    transform: translate(1000px, -1000px) skew(-80deg, -10deg);\n    -webkit-transform-origin: 0% 0%;\n    transform-origin: 0% 0%;\n    -webkit-filter: blur(40px);\n    filter: blur(40px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translate(0, 0) skew(0deg, 0deg);\n    transform: translate(0, 0) skew(0deg, 0deg);\n    -webkit-transform-origin: 50% 50%;\n    transform-origin: 50% 50%;\n    -webkit-filter: blur(0);\n    filter: blur(0);\n    opacity: 1;\n  }\n}\n\n@keyframes slide-in-blurred-tr {\n  0% {\n    -webkit-transform: translate(1000px, -1000px) skew(-80deg, -10deg);\n    transform: translate(1000px, -1000px) skew(-80deg, -10deg);\n    -webkit-transform-origin: 0% 0%;\n    transform-origin: 0% 0%;\n    -webkit-filter: blur(40px);\n    filter: blur(40px);\n    opacity: 0;\n  }\n  100% {\n    -webkit-transform: translate(0, 0) skew(0deg, 0deg);\n    transform: translate(0, 0) skew(0deg, 0deg);\n    -webkit-transform-origin: 50% 50%;\n    transform-origin: 50% 50%;\n    -webkit-filter: blur(0);\n    filter: blur(0);\n    opacity: 1;\n  }\n}\n.hide-cron {\n  background-color: #f9f9f9;\n  border-radius: 20px;\n  padding: 30px;\n  width: 590px;\n  /* position: fixed;\n  top: 30%;\n  left: 23%; */\n  z-index: 1001;\n  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;\n  animation: slide-out-blurred-tr 0.45s cubic-bezier(0.755, 0.050, 0.855, 0.060) both;\n}\n@-webkit-keyframes slide-out-blurred-tr {\n  0% {\n    -webkit-transform: translate(0, 0) skew(0deg, 0deg);\n    transform: translate(0, 0) skew(0deg, 0deg);\n    -webkit-transform-origin: 50% 50%;\n    transform-origin: 50% 50%;\n    -webkit-filter: blur(0);\n    filter: blur(0);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translate(1000px, -1000px) skew(-80deg, -10deg);\n    transform: translate(1000px, -1000px) skew(-80deg, -10deg);\n    -webkit-transform-origin: 0% 0%;\n    transform-origin: 0% 0%;\n    -webkit-filter: blur(40px);\n    filter: blur(40px);\n    opacity: 0;\n  }\n}\n\n@keyframes slide-out-blurred-tr {\n  0% {\n    -webkit-transform: translate(0, 0) skew(0deg, 0deg);\n    transform: translate(0, 0) skew(0deg, 0deg);\n    -webkit-transform-origin: 50% 50%;\n    transform-origin: 50% 50%;\n    -webkit-filter: blur(0);\n    filter: blur(0);\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: translate(1000px, -1000px) skew(-80deg, -10deg);\n    transform: translate(1000px, -1000px) skew(-80deg, -10deg);\n    -webkit-transform-origin: 0% 0%;\n    transform-origin: 0% 0%;\n    -webkit-filter: blur(40px);\n    filter: blur(40px);\n    opacity: 0;\n  }\n}\n.cron-container{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.mic-button {\n  flex-shrink: 0;\n}\n\n@keyframes pulse {\n  0%, 100% {\n      transform: scale(1);\n      color: red;\n  }\n  50% {\n      transform: scale(1.2);\n      color: blue;\n  }\n}\n\n.listening {\n  animation: pulse 1s infinite;\n}\n.rainbow-transition {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 5px;\n  background: linear-gradient(to right, violet, indigo, blue, green, yellow, orange, red);\n  background-size: 200% 200%;\n  animation: rainbow-animation 3s infinite;\n}\n\n@keyframes rainbow-animation {\n  0% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: 200% 50%;\n  }\n}\n.recommendations-container {\n  width: 80%;\n  background: rgba(243, 247, 247, 0.67);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(7.4px);\n  -webkit-backdrop-filter: blur(7.4px);\n  border: 1px solid rgba(243, 247, 247, 0.32);\n  position: absolute;\n  bottom: 100%;\n  overflow-y: hidden;\n  margin-bottom: 10px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  z-index: 100001;\n}\n.recommendation-container{\n  font-weight: 500;\n  font-size: 15px;\n  color: #4d4b4b;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  padding-left: 20px;\n}\n.recommendation-container:hover{\n  /* From https://css.glass */\nbackground: rgba(47, 104, 130, 0.47);\ncolor: #fff;\nbox-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\nbackdrop-filter: blur(7.1px);\n-webkit-backdrop-filter: blur(7.1px);\nborder-left: 5px solid #022636;\n}\n.cron-schedule-close-icon-container{\n  position: absolute;\n  padding: 3px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-radius: 50%;\n  background-color: #d1e7f1;\n  left: 90%;\n  top: 5%;\n  cursor: pointer;\n}\n.schedule-button{\n  background: var(--Gradient, linear-gradient(180deg, #2C7B74 0%, #0664AE 100%));\n  padding: 7px;\n  padding-left: 20px;\n  padding-right: 20px;\n  border-radius: 10px;\n  border-width: 0px;\n  color: #f9f9f9;\n  font-size: 15px;\n}\n.selected-popup-bg-container {\n  /* background-color: blue; */\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  width: 41%;\n  height: 59%;\n  /* max-width: 1000px;\n  max-height: 450px; */\n  border-radius: 30px;\n  /* box-shadow: 0px 3.09px 3.09px 0px rgba(0, 0, 0, 0.25); */\n  display: flex;\n  flex-direction: column;\n  opacity: 0; /* Set initial opacity to 0 */\n  z-index: 1000000000000009;\n  animation: scale-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n  /* transform: translate(-30%, -30%); */\n}\n.selected-popup-bg-container.scale-out {\n  animation: scale-out-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n}\n.selected-popup-bg-container.scale-in-top-left {\n  animation: scale-in-top-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n}\n.selected-popup-bg-container.scale-in-top-right {\n  animation: scale-in-top-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n}\n.selected-popup-bg-container.scale-in-bottom-left {\n  animation: scale-in-bottom-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n}\n.selected-popup-bg-container.scale-in-bottom-right {\n  animation: scale-in-bottom-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;\n}\n.selected-popup-bg-container.scale-out-top-left {\n  animation: scale-out-top-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n}\n.selected-popup-bg-container.scale-out-top-right {\n  animation: scale-out-top-right 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n}\n.selected-popup-bg-container.scale-out-bottom-left {\n  animation: scale-out-bottom-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n}\n.selected-popup-bg-container.scale-out-bottom-right {\n  animation: scale-out-bottom-right 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n}\n@keyframes scale-in-top-left {\n  0% {\n    transform: scale(0) translate(-100%, -100%);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1) translate(0%, 0%);\n    opacity: 1;\n  }\n}\n\n@keyframes scale-out-top-left {\n  0% {\n    transform: scale(1) translate(0%, 0%);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0) translate(-100%, -100%);\n    opacity: 1;\n  }\n}\n\n@keyframes scale-in-top-right {\n  0% {\n    transform: scale(0) translate(100%, -100%);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1) translate(0%, 0%);\n    opacity: 1;\n  }\n}\n\n@keyframes scale-out-top-right {\n  0% {\n    transform: scale(1) translate(0%, 0%);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0) translate(100%, -100%);\n    opacity: 1;\n  }\n}\n\n@keyframes scale-in-bottom-left {\n  0% {\n    transform: scale(0) translate(-100%, 100%);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1) translate(0%, 0%);\n    opacity: 1;\n  }\n}\n/* .ag-theme-balham .ag-filter-select .ag-filter-checkbox {\n  color: black !important;\n} */\n@keyframes scale-out-bottom-left {\n  0% {\n    transform: scale(1) translate(0%, 0%);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0) translate(-100%, 100%);\n    opacity: 1;\n  }\n}\n\n@keyframes scale-in-bottom-right {\n  0% {\n    transform: scale(0) translate(100%, 100%);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1) translate(0%, 0%);\n    opacity: 1;\n  }\n}\n\n@keyframes scale-out-bottom-right {\n  0% {\n    transform: scale(1) translate(0%, 0%);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0) translate(100%, 100%);\n    opacity: 1;\n  }\n}\n.file-icon{\n  font-size: 25px;\n  color: black;\n  margin-right: 10px;\n  cursor: pointer;\n  margin-bottom: 17px;\n}\n\n\n.transition-page-container{\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  /* margin-left: 15px; */\n  /* padding: 50px; */\n  /* display: flex; */\n  /* flex-wrap: wrap; */\n  /* justify-content: center; */\n  /* align-items: center; */\n}\n.transition-card-container{\n  border-radius: 10px;\n  /* width: 300px; */\n  height: 200px;\n  display: flex;\n  align-items: flex-end;\n  /* padding: 20px; */\n  /* margin-left: 10px;\n  margin-right: 10px;\n  margin-bottom: 10px; */\n  cursor: pointer;\n}\n\n\n.container-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 30px;\n  width: 100%;\n  transition: transform 0.5s ease-in-out; /* Adding smooth animation */\n}\n\n.slide-in-left {\n  animation: slideInLeft 0.5s forwards;\n}\n\n.slide-out-left {\n  animation: slideOutLeft 0.5s forwards;\n}\n\n@keyframes slideInLeft {\n  0% {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideOutLeft {\n  0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(-100%);\n  }\n}\n\n.slide-in-right {\n  animation: slideInRight 0.5s forwards;\n}\n\n.slide-out-right {\n  animation: slideOutRight 0.5s forwards;\n}\n\n@keyframes slideInRight {\n  0% {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideOutRight {\n  0% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n}\n\n\n.user-details-popup-container{\n  position: absolute;\n  /* background-image: url(\"../../assets/images/Rectangle 10.png\");\n  background-repeat: no-repeat;\n  background-size: cover; */\n  background-image: linear-gradient(to right, #233f4b, #538aa0);\n  bottom: 67%;\n  width: 80%;\n  z-index: 1000001;\n  border-radius: 15px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding: 10px;\n  right: 10%;\n}\n.IaE-user-details-popup-container{\n  position: absolute;\n  /* background-image: url(\"../../assets/images/Rectangle 10.png\");\n  background-repeat: no-repeat;\n  background-size: cover; */\n  background-image: linear-gradient(to right, #233f4b, #538aa0);\n  bottom: 140%;\n  width: 80%;\n  z-index: 1000001;\n  border-radius: 15px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding: 10px;\n  right: 10%;\n}\n.user-details-item-container{\n  background-color: transparent;\n  width: 100%;\n  padding: 15px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  text-decoration: none;\n}\n.user-details-item-container:hover {\n  border: 0px solid rgba(98, 211, 167, 0.00);\n  background: radial-gradient(231% 135.8% at 0.9% 2.98%, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.00) 100%);\n  backdrop-filter: blur(8px);\n  /* Adjust the blur value as needed */\n  width: 100%;\n  border-radius: 12.689px;\n}\n.react-grid-layout-resize-handle {\n  /* Increase the width and height to your desired size */\n  width: 20px;\n  height: 20px;\n\n  /* Add any other styles you need */\n}\n\n/* Additional styles for the hover state (optional) */\n.react-grid-layout-resize-handle:hover {\n  /* Add hover styles if needed */\n  width: 40px;\n  height: 40px;\n}\n.typewriter {\n  overflow: hidden;\n  border-right: 0.15em solid orange;\n  white-space: nowrap;\n  margin: 0 auto;\n  letter-spacing: 0.15em;\n  animation:\n    typewriterAnimation 3.5s steps(40, end),\n    blink-caret 0.75s step-end infinite;\n}\n\n@keyframes typewriterAnimation {\n  from { width: 0 }\n  to { width: 100% }\n}\n\n@keyframes blink-caret {\n  from, to { border-color: transparent }\n  50% { border-color: orange; }\n}\n.cron-menu-item{\n  padding: 20px;\n  font-weight: bold;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  /* border-radius: 20px; */\n  color: #000;\n  cursor: pointer;\n}\n.cron-menu-item-selected{\n  background-color: rgb(7, 94, 131);\n  color: #f9f9f9;\n}\n.popup-overlay {\n  position: absolute;\n  top: 0;\n  left: 19%;\n  width: 81%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n.text-color{\n  color: rgb(7, 94, 131);\n}\n.sub-text-color{\n  color: grey;\n}\n.flip-horizontal-bottom {\n  -webkit-animation: flip-horizontal-bottom 0.4s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;\n          animation: flip-horizontal-bottom 0.4s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;\n}\n\n@-webkit-keyframes flip-horizontal-bottom {\n  0%, 100% {\n    -webkit-transform: rotateX(0);\n            transform: rotateX(0);\n  }\n  50% {\n    -webkit-transform: rotateX(90deg);\n            transform: rotateX(90deg);\n  }\n}\n\n@keyframes flip-horizontal-bottom {\n  0%, 100% {\n    -webkit-transform: rotateX(0);\n            transform: rotateX(0);\n  }\n  50% {\n    -webkit-transform: rotateX(90deg);\n            transform: rotateX(90deg);\n  }\n}\n.new-toggle-button{\n  background-color: transparent;\n  border-width: 0px;\n  padding: 10px;\n  padding-left: 20px;\n}\n.new-select-toggle-button{\n  background-color: lightgrey;\n  border-radius: 30px;\n}\n\n\n.custom-button-style {\n  /* margin-right: 50px; */\n  /* margin-bottom: 45px; */\n  display: inline-block;\n  outline: 0;\n  border: 0;\n  border-radius: 6px; /* Keep the radius consistent */\n  cursor: pointer;\n  transition: box-shadow 0.15s ease, transform 0.15s ease; /* Transition should only be declared once */\n  will-change: box-shadow, transform;\n  background: #FCFCFD;\n  /* box-shadow: \n    0px 2px 4px rgb(45 35 66 / 40%), \n    0px 7px 13px -3px rgb(45 35 66 / 30%), \n    inset 0px -3px 0px #d6d6e7; */\n  /* height: 48px; */\n  padding: 10px 19px 10px 19px;\n  font-size: 1vw;\n  color: #36395a;\n  font-weight: 600;\n  text-decoration: none;\n  text-align: center;\n  background-color: #e9f0f7;\n}\n\n.custom-button-style:hover {\n  box-shadow: \n    0px 4px 8px rgb(45 35 66 / 40%), \n    0px 7px 13px -3px rgb(45 35 66 / 30%), \n    inset 0px -3px 0px #d6d6e7;\n}\n\n.custom-button-style:active {\n  box-shadow: inset 0px 3px 7px #d6d6e7;\n  transform: scale(0.98); /* Add a subtle scale effect on click */\n}\n\n@keyframes zoomIn {\n  0% {\n    transform: scale(0.5);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.zoom-in {\n  animation: zoomIn 0.5s ease-in-out;\n}\n\n.font-bold {\n  font-weight: 600;\n}\n.tooltiptext{\n  visibility: hidden;\n  width: 150px;\n  background-color: #125B9A;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 13%;\n  left: 250%;\n  margin-left: -50px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n.scrollable-container {\n  overflow-y: overlay; /* Scrollbar overlays content without occupying space */\n  /* position: relative; */\n  /* right: 0; */\n  /* background-color: blue; */\n}\n\n.scrollable-container::-webkit-scrollbar {\n  overflow-y: overlay; /* Scrollbar overlays content without occupying space */\n  position: absolute; /* Ensures the container itself is properly positioned */\n  right: 0;\n  width: 10px; /* Adjust the scrollbar width */\n  /* background-color: blue; */\n}\n\n.scrollable-container::-webkit-scrollbar-thumb {\n  background: lightgrey; /* Thumb styling for visibility */\n  border-radius: 4px; /* Rounded scrollbar thumb */\n}\n\n.scrollable-container::-webkit-scrollbar-track {\n  background-color: transparent; /* Ensures track is fully transparent */\n}\n\n.scrollable-container::-webkit-scrollbar-track-piece {\n  background-color: transparent; /* Consistent transparency across all browsers */\n}\n.react-select__menu {\n  z-index: 1050; /* Adjust based on your application's layers */\n}\n.react-select__control {\n  all: unset; /* Optional: Resets inherited styles */\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n.custom-select {\n  max-height: 150px; /* Adjust the height as needed */\n  overflow-y: auto; /* Adds scroll if content exceeds the height */\n  width: 100%; /* Ensures full width of the parent */\n  box-sizing: border-box; /* Ensures padding is included in width */\n}\n\n/* Optional: For a better look */\n.custom-select option {\n  padding: 8px; /* Adds padding to options */\n}\n/* Wrapper for the tooltip container */\n.tooltip-container {\n  /* position: relative; */\n  /* display: inline-block; */\n  /* width: 100%; */\n}\n\n/* Button or icon that triggers the tooltip */\n.tooltip-trigger {\n  cursor: pointer;\n  font-size: 1vw;\n  /* background-color: transparent; */\n  /* border: 1px solid #ccc; */\n  /* border-radius: 5px; */\n  /* padding: 10px; */\n  /* transition: background-color 0.3s ease; */\n  width: 100%;\n}\n\n.tooltip-trigger:hover {\n  /* background-color: #f0f0f0; */\n}\n\n/* Tooltip itself */\n.tooltip-text {\n  visibility: hidden; /* Initially hidden */\n  /* width: 190px; */\n  background-color: black; /* Background color of the tooltip */\n  color: #fff; /* Text color */\n  text-align: center; /* Centers the text inside */\n  border-radius: 7px;\n  padding: 5px 19px 5px 19px;\n  position: absolute;\n  z-index: 1; /* Ensures it appears above other elements */\n  opacity: 0; /* Initially invisible */\n  transition: opacity 0.3s ease-in-out; /* Fade-in effect */\n  font-size: 14px; /* Smaller text size */\n  white-space: nowrap; /* Prevents the text from wrapping */\n  max-width: 200px; /* Optional: Set a max width if needed */\n  width: auto; /* Ensure the width is auto to fit the text length */\n}\n.tooltip-text.top {\n  left: 50%;\n  top: 0%;\n  transform: translateX(-50%) translateY(-119%);\n}\n.tooltip-text.left {\n  bottom: 50%;\n  left: 0%;\n  transform: translateX(-110%) translateY(50%);\n}\n.tooltip-text.bottom {\n  top: 100%;\n  left: 0%;\n  transform: translateX(-41.5%) translateY(50%);\n}\n.tooltip-text.right {\n  top: 50%;\n  left: 130%;\n  transform: translateY(-50%);\n}\n\n/* When hovering over the tooltip container, show the tooltip */\n.tooltip-container:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1; /* Make the tooltip visible */\n}\n\n/* Tooltip Arrow styling */\n.tooltip-arrow {\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent;\n}\n\n.tooltip-arrow.top {\n  bottom: -9px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-top-color: black;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n}\n.tooltip-arrow.bottom {\n  top: 0%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-100%);\n  border-top-color: transparent;\n  border-left-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: black;\n}\n.tooltip-arrow.left {\n  top: 50%;\n  left: 100%;\n  transform: translateX(-0%) translateY(-50%);\n  border-top-color: transparent;\n  border-left-color: black;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n}\n.tooltip-arrow.right {\n  top: 50%;\n  left: 0%;\n  transform: translateX(-110%) translateY(-50%);\n  border-top-color: transparent;\n  border-left-color: transparent;\n  border-right-color: black;\n  border-bottom-color: transparent;\n}\n\n\n\n\n.popup-overlay-settings {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(78, 77, 77, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.dropdown-container {\n  display: flex;\n  flex-direction: column;\n  /* gap: 10px; */\n  width: 300px;\n  /* margin: auto; */\n}\n.disabled {\n  pointer-events: none; /* Prevents any interaction with the div */\n  opacity: 0.5; /* Reduces opacity to indicate it's disabled */\n  cursor: not-allowed;\n}\n\n\n.dropdown {\n  position: relative;\n}\n\n.dropdown-button {\n  width: 100%;\n  padding: 10px;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid lightgrey;\n  cursor: pointer;\n  border-radius: 5px;\n  text-align: left;\n}\n\n.dropdown-button:hover {\n  /* background-color: #0056b3; */\n}\n\n.dropdown-heading {\n  width: 100%;\n  padding: 10px;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid lightgrey;\n  cursor: pointer;\n  border-radius: 0px;\n  text-align: left;\n}\n\n.new-dropdown-menu {\n  position: absolute;\n  width: 100%;\n  background: white;\n  border: 1px solid #ddd;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 5px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n}\n\n.new-dropdown-item {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.new-dropdown-item:hover {\n  background-color: #f1f1f1;\n}\n\n.checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.confirm-button {\n  padding: 10px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  cursor: pointer;\n  border-radius: 5px;\n  width: 100%;\n}\n\n.confirm-button:hover {\n  background-color: #218838;\n}\n\n.result-box {\n  background: #f8f9fa;\n  padding: 10px;\n  border-radius: 5px;\n  font-size: 14px;\n  white-space: pre-wrap;\n}\n\n.restricted-content{\n  font-size: 14px;\n  table-layout: fixed;\n  width: 100%;\n}\n.restricted-content h1,\n.restricted-content h2,\n.restricted-content h3,\n.restricted-content h4,\n.restricted-content h5,\n.restricted-content h6,\n/* .restricted-content strong, */\n.restricted-content b {\n  display: inline !important;\n  font-size: 15px !important;\n  font-weight: bold !important; /* Optional: remove bold effect */\n} \n.restricted-content strong {\n  display: inline !important;\n  font-size: 14px !important;\n  font-weight: 600 !important; /* Optional: remove bold effect */\n} \n.restricted-content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 10px 0;\n  font-size: 14px;\n  table-layout: auto;\n  overflow-x: auto;\n  display: block;\n  border: 1px solid #efefef; /* Outer border */\n  border-radius: 4px; /* Optional: rounded corners */\n}\n\n.restricted-content th,\n.restricted-content td {\n  border: 1px solid #efefef;\n  padding: 10px 14px;\n  text-align: center;\n  vertical-align: center;\n  font-size: 14px !important;\n}\n.restricted-content th{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 170px;\n  max-width: 250px;\n}\n.restricted-content td {\n  /* max-width: 250px; */\n  word-wrap: break-word;     /* allow long words to break */\n  white-space: normal;       /* allow line breaks */\n  overflow-wrap: anywhere;   /* modern fallback */\n}\n\n\n.restricted-content thead {\n  background-color: #f2f2f2;\n}\n\n.restricted-content tbody tr:nth-child(even) {\n  /* background-color: #e4d1d1; */\n}\n\n.restricted-content tbody tr:hover {\n  background-color: #f9f9f9;\n}\n\n\n.restricted-content tbody tr {\n  border: 1px solid #eaeaea;\n}\n\n/* Optional: make table scrollable on small screens */\n.restricted-content table {\n  overflow-x: auto;\n  display: block;\n  white-space: nowrap;\n}\n.restricted-content li {\n  font-size: 14px !important;\n  font-weight: normal !important; /* Optional: remove bold effect */\n  margin-top: 5px;\n} \n.restricted-content td.matched {\n  background-color: rgb(190, 249, 190, 0.3);\n} \n.restricted-content td.discrepancy {\n  background-color: rgba(253, 199, 204, 0.3);\n} \n.restricted-content td.missing {\n  background-color: rgba(253, 199, 204, 0.3);\n} \n\n.gpt-response h1, \n.gpt-response h2, \n.gpt-response h3 {\n  margin-top: 1rem;\n  font-weight: 600;\n  font-size: 17px;\n}\n\n.gpt-response p {\n  margin-bottom: 0.75rem;\n  line-height: 1.6;\n  font-size: 15px;\n}\n\n.gpt-response strong {\n  /* margin-bottom: 0.75rem; */\n  /* line-height: 1.6; */\n  font-size: 15px;\n  font-weight: 600;\n  display: inline;\n}\n\n.gpt-response ul {\n  padding-left: 1.2rem;\n  margin-bottom: 1rem;\n  font-size: 15px;\n}\n\n.gpt-response li {\n  margin-bottom: 0.5rem;\n  font-size: 15px;\n  /* list-style-type: circle; */\n}\n\n.gpt-response code {\n  background: #f8f9fa;\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 15px; \n}\n.hover-container {\n               /* darker text */\n}\n.hover-container:hover {\n  background-color: #e9e9e9;   /* subtle darker bg */\n  border-color: #bbb;          /* darker border */\n  transform: scale(1.03);      /* slight zoom */\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.15); /* shadow pop */\n  color: #333;                 /* darker text */\n}\n/* Left section gradient */\n.left-section {\n  background: linear-gradient(to bottom, rgb(14,88,214, 0.1), rgb(14,88,214,0.05));;\n}\n\n/* Marquee */\n.marquee-container {\n  height: 350px;\n  width: 500px;\n}\n\n.marquee {\n  display: flex;\n  animation: marquee 10s linear infinite;\n}\n\n@keyframes marquee {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(-50%); }\n}\n\n/* Org card */\n.org-card {\n  width: 270px;\n  height: 200px;\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n.org-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(0,0,0,0.15);\n}\n/* Continuous expand & shrink pulse */\n@keyframes pulse-breath {\n  0%, 100% {\n    transform: scale(0.3);\n    opacity: 0.6;\n  }\n  50% {\n    transform: scale(6); /* expand bigger */\n    opacity: 0.3;          /* fade slightly */\n  }\n}\n\n.pulse-ring {\n  position: absolute;\n  border-radius: 50%;\n  animation: pulse-breath 2.5s infinite ease-in-out;\n}\n.wave {\n  width: 0.5rem;\n  background-color: #0d6efd; /* Bootstrap primary */\n  border-radius: 0.25rem;\n  transform-origin: center; /* expand from center */\n  transition: transform 0.1s ease; /* smooth scaling */\n}\n.recording-container {\n  position: relative;\n  width: 180px;\n  height: 180px;\n  margin: 20px auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mic-btn {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  font-size: 36px;\n  z-index: 5;\n}\n\n/* Rings */\n.pulse-ring {\n  position: absolute;\n  border-radius: 50%;\n  /* animation: pulse 2s infinite; */\n  opacity: 0.6;\n}\n\n.ring1 {\n  width: 105px;\n  height: 105px;\n  background: rgba(13, 110, 253, 0.2);\n  animation-delay: 0s;\n}\n.ring2 {\n  width: 75px;\n  height: 75px;\n  background: rgba(13, 110, 253, 0.3);\n  animation-delay: 0.3s;\n}\n.ring3 {\n  width: 45px;\n  height: 45px;\n  background: rgba(13, 110, 253, 0.4);\n  animation-delay: 0.6s;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(0.9);\n    opacity: 0.7;\n  }\n  50% {\n    transform: scale(1.3);\n    opacity: 0.3;\n  }\n  100% {\n    transform: scale(0.9);\n    opacity: 0.7;\n  }\n}\n\n/* Bars */\n.bars-container {\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 6px;\n  height: 80px;\n  margin-top: 20px;\n}\n\n.bar {\n  width: 8px;\n  background-color: #0d6efd;\n  border-radius: 4px;\n  animation: wave 1s ease-in-out infinite;\n  transform-origin: center;\n}\n\n@keyframes wave {\n  0%, 100% {\n    transform: scaleY(0.6);\n  }\n  50% {\n    transform: scaleY(1.3);\n  }\n}\n\n/* Transcript box */\n.transcript-box {\n  background: rgba(240, 240, 240, 0.9);\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid #ddd;\n}\n\n.restricted-content{\n  font-size: 1vw;\n  width: 100%;\n  flex-grow: 1;\n}\n.restricted-content h1,\n.restricted-content h2,\n.restricted-content h3,\n.restricted-content h4,\n.restricted-content h5,\n.restricted-content h6,\n/* .restricted-content strong, */\n.restricted-content b {\n  display: inline !important;\n  font-size: 1.1vw !important;\n  font-weight: bold !important; /* Optional: remove bold effect */\n} \n.restricted-content strong {\n  display: inline !important;\n  font-size: 1vw !important;\n  font-weight: 600 !important; /* Optional: remove bold effect */\n} \n/* .restricted-content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1em 0;\n  font-size: 1vw;\n  display: block;\n  border: 2px solid #efefef;\n  border-radius: 4px;\n} */\n\n.restricted-content th,\n.restricted-content td {\n  border: 1px solid #efefef;\n  padding: 0.7vw 0.95vw;\n  text-align: left;\n  vertical-align: center;\n  font-size: 0.9vw !important;\n}\n\n\n.restricted-content thead {\n  background-color: #f2f2f2;\n}\n\n.restricted-content tbody tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.restricted-content tbody tr:hover {\n  background-color: #f0f0f0;\n}\n\n\n.restricted-content li {\n  font-size: 0.9vw !important;\n  font-weight: normal !important; /* Optional: remove bold effect */\n  margin-top: 5px;\n} \n.restricted-content td.matched {\n  background-color: rgb(190, 249, 190, 0.3);\n} \n.restricted-content td.discrepancy {\n  background-color: rgba(253, 199, 204, 0.3);\n} \n.restricted-content td.missing {\n  background-color: rgba(253, 199, 204, 0.3);\n} \n\n\n.custom-table-style table {\n  width: 100%;\n  height: 100%;\n  table-layout: auto;\n  border-collapse: collapse;\n  margin: 0;\n  font-size: 1vw;\n  overflow-x: auto;\n  /* display: block; */\n  white-space: normal;\n  border: 0px solid #efefef;\n  border-radius: 4px;\n}\n\n.custom-table-style th,\n.custom-table-style td {\n  padding: 0.3vw 0.5vw;\n  text-align: left;\n  vertical-align: center;\n  font-size: 0.9vw !important;\n  /* white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: anywhere; */\n  border: 1px solid #efefef;\n  font-weight: 500;\n  text-align: center;\n}\n\n.custom-table-style th {\n  /* white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; */\n  font-weight: bold;\n  font-size: 1vw !important;\n  padding: 0.75vw 0.5vw;\n  background-color: lightgrey;\n  padding: 0.3vw 0.5vw;\n  border: 0px solid #efefef;\n}\n\n.custom-table-style thead {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.custom-table-style tbody tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.custom-table-style tbody tr:hover {\n  background-color: #f0f0f0;\n}\n\n.custom-table-style td.matched {\n  background-color: rgba(190, 249, 190, 0.3);\n}\n\n.custom-table-style td.discrepancy,\n.custom-table-style td.missing {\n  background-color: rgba(253, 199, 204, 0.3);\n}\n\n\n.restricted-content{\n  font-size: 1vw;\n  table-layout: fixed;\n  width: 100%;\n}\n.restricted-content h1,\n.restricted-content h2,\n.restricted-content h3,\n.restricted-content h4,\n.restricted-content h5,\n.restricted-content h6,\n/* .restricted-content strong, */\n.restricted-content b {\n  display: inline !important;\n  font-size: 1.1vw !important;\n  font-weight: bold !important; /* Optional: remove bold effect */\n} \n.restricted-content strong {\n  display: inline !important;\n  font-size: 1vw !important;\n  font-weight: 600 !important; /* Optional: remove bold effect */\n} \n.restricted-content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0;\n  font-size: 1vw;\n  table-layout: auto;\n  overflow-x: auto;\n  /* display: block; */\n  border: 0px solid #efefef; /* Outer border */\n  border-radius: 4px; /* Optional: rounded corners */\n}\n\n.restricted-content th,\n.restricted-content td {\n  border: 1px solid #efefef;\n  padding: 0.7vw 0.95vw;\n  text-align: left;\n  vertical-align: top;\n  font-size: 0.9vw !important;\n  min-width: 13vw;\n  max-width: 17vw;\n}\n.restricted-content th{\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border: 0px solid #efefef;\n}\n.restricted-content td {\n  /* max-width: 250px; */\n  word-wrap: break-word;     /* allow long words to break */\n  white-space: normal;       /* allow line breaks */\n  overflow-wrap: anywhere;   /* modern fallback */\n}\n\n\n.restricted-content thead {\n  background-color: #f2f2f2;\n}\n\n.restricted-content tbody tr:nth-child(even) {\n  background-color: #fafafa;\n}\n\n.restricted-content tbody tr:hover {\n  background-color: #f0f0f0;\n}\n\n/* Optional: make table scrollable on small screens */\n.restricted-content table {\n  overflow-x: auto;\n  /* display: block; */\n  white-space: nowrap;\n}\n.restricted-content li {\n  font-size: 0.9vw !important;\n  font-weight: normal !important; /* Optional: remove bold effect */\n  margin-top: 0.35vw;\n} \n.restricted-content td.matched {\n  background-color: rgb(190, 249, 190, 0.3);\n} \n.restricted-content td.discrepancy {\n  background-color: rgba(253, 199, 204, 0.3);\n} \n.restricted-content td.missing {\n  background-color: rgba(253, 199, 204, 0.3);\n} \n.restricted-content thead,\n.restricted-content tfoot {\n  background-color: #f2f2f2;\n  z-index: 10;\n}\n.upload-btn-1{\n  color: rgb(14, 88, 214)!important;\n  padding: 0.19vw 0.7vw!important;\n  border-radius: 0.3vw!important;\n}\n.upload-btn-1:hover{\n  color: #f9f9f9!important;\n}\n.restricted-content tfoot {\n  background-color: #eaeaea;\n}\n.sticky-col-1 {\n  position: sticky;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #f2f2f2;\n  z-index: 3;\n  /* min-width: 150px; */\n}\n\n.sticky-col-2 {\n  position: sticky;\n  left: 0px; /* width of previous column */\n  right: 0;\n  background-color: #f9f9f9;\n  z-index: 3;\n  /* min-width: 150px; */\n}\n.sticky-col-3 {\n  position: sticky;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #f2f2f2;\n  z-index: 3;\n  /* min-width: 150px; */\n}\n.ai-loader {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  background: radial-gradient(circle, #0e58d6 35%, transparent 25%);\n  animation: pulse 1.5s infinite ease-in-out;\n  margin: auto;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  50% {\n    transform: scale(1.2);\n    opacity: 1;\n  }\n}\n.success-checkmark {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  display: inline-block;\n  border: 4px solid #4caf50;\n  position: relative;\n  box-sizing: content-box;\n}\n\n.check-icon {\n  width: 100px;\n  height: 100px;\n  position: relative;\n}\n\n.icon-line {\n  height: 5px;\n  background-color: #4caf50;\n  display: block;\n  border-radius: 2px;\n  position: absolute;\n  transform-origin: left;\n}\n\n.line-tip {\n  width: 25px;\n  top: 50px;\n  left: 28px;\n  transform: rotate(45deg);\n  animation: tip 0.3s ease-out forwards;\n}\n\n.line-long {\n  width: 47px;\n  top: 45px;\n  left: 28px;\n  transform: rotate(-45deg);\n  animation: long 0.3s ease-out 0.3s forwards;\n}\n\n.icon-circle {\n  top: -4px;\n  left: -4px;\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  border: 4px solid rgba(76, 175, 80, 0.5);\n  position: absolute;\n  box-sizing: content-box;\n}\n\n@keyframes tip {\n  0% { width: 0; left: 28px; top: 50px; }\n  100% { width: 25px; left: 28px; top: 50px; }\n}\n\n@keyframes long {\n  0% { width: 0; left: 28px; top: 45px; }\n  100% { width: 47px; left: 28px; top: 45px; }\n}\n.checkmark-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100px;\n}\n\n.check-icon {\n  width: 100px;\n  height: 100px;\n  position: relative;\n}\n\n.icon-circle {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  border: 5px solid #4caf50;\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  left: 0;\n  animation: circle-scale 0.6s ease-out forwards;\n}\n\n.ellipsis-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;       /* or inline-block */\n  width: 100%;          /* or a fixed px value like 150px */\n}\n\n\n.icon-line {\n  height: 5px;\n  background-color: #4caf50;\n  display: block;\n  border-radius: 2px;\n  position: absolute;\n  transform-origin: left;\n}\n\n.line-tip {\n  width: 0;\n  top: 50px;\n  left: 26px;\n  transform: rotate(45deg);\n  animation: draw-tip 0.3s ease-out 0.3s forwards;\n}\n\n.line-long {\n  width: 0;\n  top: 50px;\n  left: 26px;\n  transform: rotate(0deg);\n  animation: draw-long 0.3s ease-out 0.6s forwards;\n}\n\n/* Keyframes */\n@keyframes circle-scale {\n  0% { transform: scale(0.8); opacity: 0.5; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n@keyframes draw-tip {\n  0% { width: 0; }\n  100% { width: 25px; }\n}\n\n@keyframes draw-long {\n  0% { width: 0; }\n  100% { width: 47px; }\n}\n.excel-table table {\n  border-collapse: collapse;\n  width: 100%;\n  font-family: Arial, sans-serif;\n  font-size: 14px;\n  color: #1e293b;\n}\n\n.excel-table th {\n  background: #f1f5f9;\n  font-weight: bold;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  text-align: left;\n}\n\n.excel-table td {\n  padding: 6px 10px;\n  border: 1px solid #e2e8f0;\n  min-width: 150px;\n}\n\n.excel-table tr:nth-child(even) {\n  background: #f9fafb;\n}\n\n.excel-table tr:hover {\n  background: #e0f2fe;\n}\n\n.file-grid.ag-theme-balham .ag-cell {\n  display: flex;\n  justify-content: center;\n  align-items: center;   /* vertical centering */\n  font-weight: 500;\n}\n.file-grid.ag-theme-balham .ag-header-cell-label {\n  justify-content: center;   /* horizontal center */\n  align-items: center;       /* vertical center */\n  display: flex;             /* required */\n  font-weight: bold;\n  color: #000;\n  font-size: 14px;\n  /* background-color: blue; */\n}\n.rs-picker-popup {\n  z-index: 99999 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
